import {ssxWorkerRequested} from './ssx-worker-opt-in.mjs';
import {createControllerInput} from './controller-input.mjs';
import {inputHints,navigateControllerMenu} from './input-hints.mjs';
import {preserveCityCourseVisuals} from "./ssx-city-course-gates.mjs";
import {SSX_COURSE_DESTINATIONS,ssxCatalogDestination} from './ssx-course-destinations.mjs';
import {createViewTransition,vrThirdPersonPose,blendViewPose} from './view-transition.mjs';
import {originalCourseConfig} from './ssx-original-course-ui.mjs';
import {isSsxEntryPath,createSsxEntryPresentation} from './ssx-entry-presentation.mjs';
import {returnedValoriaPlayer,createValoriaReturnAction} from './return-valoria.mjs';
import {createFirstPersonEyeAnchor} from './first-person-eye-anchor.mjs';
import {localFirstPersonAvatar} from './local-avatar-presentation.mjs';
import {createFirstPersonBody} from './first-person-body.mjs';
import {createFirstPersonHeading,firstPersonBodyHeading,headRelativeMovement} from './first-person-heading.mjs';
import {createViewPreference,firstPersonCameraPose} from './view-mode.mjs';
import {installXRPresentation} from './xr-presentation.mjs';
import {reconcilePortalHandoff,stepPortalPrediction} from './portal-handoff.mjs';
// Generated guarded client overlay for live base 184ea8724b1b8db46247d5c506bca852eb9f458c. Original sources are unchanged.
import {mountCatalogBrowser,worldCatalogItems,catalogThumbnail,readCatalogFavorites,saveCatalogFavorites} from './catalog-browser.mjs';
import {installActivityDrawer} from './activity-drawer.mjs';
import {createDefaultRegion} from './region.mjs';
import {createArrivalRecovery} from './arrival-recovery.mjs';
import {resortInteractionCandidates,isTrustedMirage} from './resort-cabinets.mjs';
import {createWorldMinimap} from './snowjam-world-minimap.mjs';
import {applyPatch,PATCH_CONTRACT} from './world-contract.mjs';
import {takeInviteToken} from './friend-invite-link.mjs';
import {createActivityView,activityText} from './activity-view.mjs';
const publicActivity=createActivityView();
import {consumeAccountReturn} from './account-access.mjs';
import {createAccountModal} from './account-modal.mjs';
import {profileSummaryMarkup,profileEditorMarkup,accountSummaryMarkup,directoryHeadingMarkup,avatarHeadingMarkup,headerWorldName} from './hud-presentation.mjs';
import {mountResortGames} from './resort-games-ui.mjs';
import {suggestedProfileName} from './profile-link.mjs';
import * as T from "three";
import { createArrivalTransition } from "./arrival-transition.mjs";
import { CITY_COLLIDERS } from "./city.mjs";
import { createWorldScene } from "./world-scene.mjs";
import { createPortalRenderer } from "./portals.mjs";
import * as snowJamPortalModule from "./portals.mjs";
import { createPortalStraddling } from "./portal-straddling.mjs";
import { addNpcBadge } from "./npc-avatar.mjs";
import { createRemotePresence } from "./remote-presence.mjs";
import { stepPortalCrossing, selectedPortals } from "./portal-math.mjs";
import * as snowJamPortalMath from "./portal-math.mjs";
import {blockedModelPortalWorldIds,isModelDestinationReady} from "./portal-readiness.mjs";
import { routeCameraThroughPortal } from "./camera-portals.mjs";
import {publishNativeCamera,createPendingCameraTraversal,cameraRouteHeading,withPendingBodyPresentation} from "./camera-presentation.mjs";
const pendingCameraTraversal=createPendingCameraTraversal();
import { createAvatar, loadAvatars } from "./avatar.mjs";
import {mountAvatarPicker,createAvatarSelectionSaver} from "./avatar-picker.mjs";
import {needsProfileSetup,profileLabel,applyProfileSnapshot} from "./avatar-profile.mjs";
import { stepMovement, worldColliders, flightAllowed } from "./movement.mjs";
import { installWorldControls } from "./input.mjs";
import { inputNeedsImmediateSend } from "./input-send.mjs";
import { createSocketMovementReconciliation } from "./socket-movement-reconciliation.mjs";
const socketMovementReconciliation=createSocketMovementReconciliation();
import { installMobileControls } from "./mobile-controls.mjs";
import { installComposer } from "./composer.mjs";
import {composerAvailability} from "./composer-availability.mjs";

import {createNativeOwnerUi} from "./owner-creation/browser/native-ui.mjs";
import { renderCreationHistory } from "./creation-history.mjs";
import { createHttpWorldTransport } from "./http-transport.mjs";
import { createMovementPrediction } from "./movement-prediction.mjs";
import { localWorldImportCandidate } from "./local-import.mjs";
import { createLiveContentSync } from "./live-content.mjs";
import { canPlacePortalBetween, createPlacedPortalPair } from "./portal-placement.mjs";
import {createPortalPlacementPreview} from "./portal-placement-preview.mjs";
import {mountOwnedPortalManager} from "./owned-portal-manager.mjs";
import { clampCameraArm } from "./camera.mjs";
import { CAMERA_FRAMING, minimumCameraDistance, orbitCameraPose, orbitLookAngles } from "./camera-framing.mjs";
import { sanitizePlayerPosition, prepareSpawnSafety, isSpawnSafetyPrepared } from "./spawn-safety.mjs";
import { createDeferredPersistence } from "./deferred-persistence.mjs";
import { createPerformanceCapture } from "./performance-capture.mjs";
import { createSeedWorlds, DEFAULT_AVATAR, normalizeWorldPortalLinks, normalizeSystemWorldGeometry } from "./world-seeds.mjs";
import moonwater from "./moonwater.patch.json";
const $ = (s) => document.querySelector(s), escape = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
const LOCAL = window.VALORIA_PREVIEW === true || new URLSearchParams(location.search).get("preview") === "1";
let pendingInviteToken=takeInviteToken(location,history);
const state = { region:createDefaultRegion(), player: null, world: null, worlds: [], players: /* @__PURE__ */ new Map(), socket: null, localWorlds: null, panel: null, time: 0, connected: false, sound: false, near: null, waveUntil: 0 };
let scene, renderer, camera, worldRoot, atmosphere, city, entities, avatar, avatarPreview, previewRenderer, previewScene, previewCamera, lastSave = 0, frame = 0, camYaw = 0, camPitch = CAMERA_FRAMING.initialPitch, camDistance = window.matchMedia("(pointer: coarse)").matches ? CAMERA_FRAMING.phoneInitialDistance : CAMERA_FRAMING.initialDistance, seq = 0, inputTimer = 0;
const movementPrediction = createMovementPrediction({resolveMovement:snowJamConstrainCityMovement,captureMovementConstraint:snowJamCaptureCityMovementConstraint});
const keys = /* @__PURE__ */ new Set(), clock = new T.Clock(), cameraTarget = new T.Vector3(), cameraDesired = new T.Vector3();
let viewStorage;try{viewStorage=window.localStorage;}catch{}
const viewPreference=createViewPreference(viewStorage);
let xrPresentation;
const firstPersonBody=createFirstPersonBody({THREE:T});
const firstPersonHeading=createFirstPersonHeading({THREE:T});
const firstPersonEye=createFirstPersonEyeAnchor({THREE:T});
function standingAvatarEye(){return firstPersonEye.calibratedEye({avatarRoot:avatar?.root,avatarBody:avatar?.body,preset:avatar?.preset}).position;}
function firstPersonBodyLocomotion(){
  const activityOwned=snowJamOwnsFrame(),riding=activityOwned&&snowJamMount?.xrRiding?.()===true;
  const player=activityOwned?snowJamWalkingInputContext()?.player:state.player;
  return {player,walking:!riding&&player?.grounded===true&&player?.flying!==true,riding,animationState:avatar?.animationState,time:state.time};
}
function toggleCameraView(){viewPreference.toggle();cameraArmLength=Infinity;xrPresentation?.refresh();}
const standardController=createControllerInput();
let controllerSample={}, activeInputDevice='keyboard', controllerHint=null;
function controllerMenuOpen(){const el=document.activeElement;return !!state.panel||accountAccessPanel?.isOpen===true||!$('#tool-menu')?.hidden||!!el?.closest?.('input,textarea,select,button,summary,[contenteditable="true"]');}
function updateController(dt){
  let pads=[];try{pads=navigator.getGamepads?.()??[];}catch{}
  const xr=xrPresentation?.active()===true, menu=controllerMenuOpen(), riding=snowJamMount?.xrRiding?.()===true;
  controllerSample=standardController.read(pads,{enabled:!xr&&!document.hidden&&document.hasFocus()&&!!state.player,mode:riding?'ssx':'walk',menu});
  if(controllerSample.active)activeInputDevice=controllerSample.profile;
  if(controllerSample.profile==='unmapped')activeInputDevice='unmapped';
  else if(!pads.some?.(p=>p?.connected&&p.mapping==='standard')&&['xbox','playstation','standard','unmapped'].includes(activeInputDevice))activeInputDevice='keyboard';
  for(const action of controllerSample.actions){
    if(menu)navigateControllerMenu(document,action,{root:[...document.querySelectorAll('[aria-modal="true"]')].find(el=>!el.closest('[hidden],[inert]')&&el.getClientRects().length)??(state.panel?$('#panel'):!$('#tool-menu').hidden?$('#tool-menu'):document),onBack:()=>{if(accountAccessPanel?.isOpen){accountAccessPanel.close({restoreFocus:false});focusWorld();}else if(state.panel)closePanel({restoreFocus:true});else {composer?.setMenu(false);document.activeElement?.blur?.();focusWorld();}}});
    else if(action==='menu'){controls?.releasePointer();$('#menu-button')?.click();controllerSample={};}
    else if(action==='view')toggleCameraView();
    else if(action==='interact'){if(snowJamOwnsFrame())snowJamMount?.xrInteract?.();else interact();}
  }
  if(riding&&(controllerSample.lookX||controllerSample.lookY))snowJamMount?.onLook?.(controllerSample.lookX*dt*2.15/.0022,controllerSample.lookY*dt*1.6/.0022);
  const root=$('.controls');
  if(root&&!controllerHint){for(const child of root.children)child.style.display="none";controllerHint=document.createElement('span');controllerHint.id='device-control-hints';root.append(controllerHint);const style=document.createElement('style');style.textContent='html body.valoria-ui .bottom-ui>.controls:has(#device-control-hints){display:flex!important;max-width:100%;white-space:normal;text-align:center;line-height:1.5} #device-control-hints{max-width:900px;padding:4px 10px;background:#080d1dcc;border-radius:8px} @media(max-width:600px){#device-control-hints{font-size:9px;max-height:54px;overflow:auto}}';document.head.append(style);}
  if(controllerHint){const contextual=xr||riding||activeInputDevice!=='keyboard';controllerHint.hidden=!contextual;for(const child of root.children)if(child!==controllerHint)child.style.display=contextual?'none':'';root.classList.toggle('quiet',!contextual&&(state.time>8||menu));const text=inputHints({device:xr?'xr':activeInputDevice,mode:menu?'menu':riding?'ssx':'walk',flying:state.player?.flying});if(controllerHint.textContent!==text)controllerHint.textContent=text;root.title=text;}
}
const hostViewTransition=createViewTransition();let hostViewBlend=null;
const hostViewIsTransitioning=()=>hostViewBlend!==null&&hostViewBlend>0&&hostViewBlend<1;
function viewCameraPose(position,mode=viewPreference.get()){if(mode==='third-person')return xrPresentation?.active()?vrThirdPersonPose(position,camYaw):orbitCameraPose(position,camYaw,camPitch,camDistance,camera.aspect);const offset=standingAvatarEye();if(avatar?.root)offset.applyQuaternion(avatar.root.quaternion);const pose=firstPersonCameraPose(position,camYaw,camPitch,offset.y,offset);return {target:pose.desired,desired:{x:pose.desired.x+Math.sin(camYaw)*.001,y:pose.desired.y,z:pose.desired.z+Math.cos(camYaw)*.001}};}
function combinedTouch(){const touch=mobileControls?.sample()||{},xr=xrPresentation?.input()||{},pad=controllerSample;const flightToggle=touch.flightToggle||xr.flightToggle||pad.flightToggle;pad.flightToggle=false;return {...touch,lookX:(touch.lookX||0)+(pad.lookX||0),lookY:(touch.lookY||0)+(pad.lookY||0),moveX:(touch.moveX||0)+(xr.moveX||0)+(pad.moveX||0),moveZ:(touch.moveZ||0)+(xr.moveZ||0)+(pad.moveZ||0),jump:touch.jump||xr.jump||pad.jump,sprint:touch.sprint||xr.sprint||pad.sprint,moveY:(touch.moveY||0)+(xr.moveY||0)+(pad.moveY||0),flightToggle};}
let resortPanel,accountAccessPanel,avatarPicker,lastLocalSaveError;
let worldCatalog,ownedPortalManager;
const directoryBrowseState={worlds:{},avatar:{}};
const saveAvatarSelection=createAvatarSelectionSaver({getPlayer:()=>state.accountRefreshRequired?null:state.player,local:LOCAL,api,persist:()=>{persist();localSaver.flush({force:true});if(lastLocalSaveError)throw lastLocalSaveError;},apply:snowJamApplySelectedAvatar});
let toastTimer, audioContext, preferredPortal = null, pendingAtelierPortal = null, controls, mobileControls, cameraArmLength = Infinity, lastSentInput = null;
let liveContent, httpTransport, portals, straddling, remotePresence, activeView, renderView, renderWorldId = null, lastWorldRefresh = 0, refreshPending = false;
const worldCache = /* @__PURE__ */ new Map();
const diagnostics=createPerformanceCapture();
window.valoriaDiagnostics={start:()=>diagnostics.start(),stop:()=>diagnostics.stop(),snapshot:()=>diagnostics.snapshot({snowJam:snowJamMount?.diagnostics?.()??null,portal:portals?.getStats(),persistence:localSaver.getStats(),visualPreparation:straddling?.getPreparationStats(),localAvatarPrepared:straddling?.isPrepared(`player:${state.player?.id}`)??false})};

// BEGIN SNOWJAM CLIENT BOUNDARY (generated; default disabled)
const snowJamConfig = originalCourseConfig(window.VALORIA_SNOWJAM,window.location);
const snowJamEnabled = !LOCAL && snowJamConfig?.enabled === true;
const snowJamDirectRoute = isSsxEntryPath(window.location?.pathname);
const snowJamSignInReturnTo = snowJamDirectRoute ? window.location.pathname + (window.location.search ?? '') + (window.location.hash ?? '') : '/';
const ssxPresentation = createSsxEntryPresentation({direct:snowJamDirectRoute,document,history:window.history,location:window.location});
ssxPresentation.render();
let snowJamMount = null, snowJamInitialStatus = null, snowJamCitySuspended = false;
let snowJamPreservingMinimapCollapse = false;
let snowJamBoundaryError = null, snowJamResetting = false, snowJamCityCamera = null, snowJamWasFrameOwned = false;
let snowJamWalkingCamera = null, snowJamWalkingCameraAspect = null;
let snowJamReturnedCamera = null, snowJamReturnedCameraAspect = null, snowJamReturnedCameraPortal = null;
let snowJamWalkingContext = null, snowJamWalkingArmLength = Infinity, snowJamCityReturnArm = null, snowJamWalkingTraversal = null;
const snowJamSourceWorld = world => world?.id === 'snowjam' || world?.worldId === 'snowjam' || world?.activity?.kind === 'snowjam' || world?.authoring?.activity === 'snowjam';
const snowJamSourcePlayer = player => player?.worldId === 'snowjam';
function snowJamOwnsFrame() {
  return !!(snowJamBoundaryError || snowJamCitySuspended || snowJamMount?.ownsFrame());
}
// Browsing native menus never changes activity ownership. Only a chosen world
// action crosses the acknowledged activity boundary before native placement.
async function snowJamPrepareWorldAction() {
  if (!snowJamOwnsFrame()) {
    try {
      if(ssxPresentation.active()&&snowJamMount&&await snowJamMount.returnForWorldAction?.()!==true)return false;
      return true;
    } catch(error) { toast(error.message ?? String(error)); return false; }
  }
  try {
    if (snowJamBoundaryError || typeof snowJamMount?.returnForWorldAction !== 'function') throw Error('Use Back to city before placing a world doorway.');
    const returned = await snowJamMount.returnForWorldAction();
    if (!returned || snowJamOwnsFrame() || snowJamSourcePlayer(state.player) || snowJamSourceWorld(state.world)) throw Error('The city return is not confirmed yet. Try again after returning to the city.');
    return true;
  } catch (error) { toast(error.message ?? String(error)); return false; }
}
async function snowJamSaveAvatarChoice(config, profile) {
  return saveAvatarSelection(config, profile);
}
function snowJamRenderMenuPreview(dt) {
  if (typeof previewRenderer === 'undefined' || !previewRenderer || !['avatar','onboarding','profile','account'].includes(state.panel)) return;
  avatarPreview.update(dt, state.time, 0);
  avatarPreview.root.rotation.y = Math.sin(state.time * 0.3) * 0.18;
  previewRenderer.render(previewScene, previewCamera);
}
function snowJamApplySelectedAvatar(config) {
  return snowJamMount?.customizeAvatar ? snowJamMount.customizeAvatar(config,true) : avatar.customize(config,true);
}
function snowJamLimitAvatarPicker(root) {
  if (!snowJamOwnsFrame()) return;
  const remix = root.querySelector('#remix-avatar');
  if (!remix) return;
  const note = document.createElement('p'); note.className = 'note'; note.id = 'snowjam-avatar-note';
  note.textContent = 'Use Back to city before creating a new avatar.';
  const actions = document.createElement('fieldset'); actions.disabled = true;
  actions.style.cssText = 'border:0;padding:0;margin:0';
  remix.setAttribute('aria-describedby',note.id); remix.parentNode.insertBefore(actions,remix); actions.append(remix); actions.before(note);
}
function snowJamCaptureCityMovementConstraint(_player,world) {
  return snowJamMount?.cityMovementConstraint?.(world) ?? null;
}
function snowJamConstrainCityMovement(previous,moved,dt,world,constraint) {
  return snowJamMount?.constrainCityMovement?.(previous,moved,dt,world,constraint) ?? moved;
}
function snowJamOrdinaryWorld(world) {
  if (!world) return world;
  if (snowJamSourceWorld(world)) throw Object.assign(Error('Snow Jam must be opened through its activity doorway.'), {code:'SNOWJAM_ACTIVITY_REQUIRED'});
  const portals = world.portals?.filter(portal => portal.targetWorldId !== 'snowjam' && portal.id !== 'snowjam-entry');
  return portals && portals.length !== world.portals.length ? preserveCityCourseVisuals(world, {...world, portals}) : world;
}
function snowJamOrdinaryWorlds(worlds) {
  return Array.isArray(worlds) ? worlds.filter(world => !snowJamSourceWorld(world)).map(snowJamOrdinaryWorld) : worlds;
}
// Course destinations stay activity entries, never duplicate editable worlds.
const snowJamCatalogEntries=Object.freeze(SSX_COURSE_DESTINATIONS.map(course=>Object.freeze({
 id:course.catalogId,name:course.label,courseId:course.id,kind:'activity',current:false,
 description:'Enter '+course.label+' on the connected SSX 3 mountain. Place a portal here, then walk or fly through it.',
 tags:Object.freeze(['SSX','SSX3','snowboarding','snow',course.label]),filters:Object.freeze(['activities']),badge:'SSX 3 course',thumbnail:null,
})));
function snowJamCatalogReady(){return snowJamEnabled&&typeof snowJamMount?.refreshAvailability==='function';}
function snowJamAvailableCourses(){const available=snowJamMount?.status?.().courseDestinations;return new Set(Array.isArray(available)?available.map(c=>c.id):['snowjam']);}
function snowJamCatalogItems(items){const available=snowJamAvailableCourses();return snowJamCatalogReady()?[...items,...snowJamCatalogEntries.filter(item=>available.has(item.courseId))]:items;}
function snowJamCatalogFilters(){return snowJamCatalogReady()?[['activities','SSX 3']]:[];}
function snowJamSelectCatalogItem(item,showActivity){
 if(!snowJamCatalogEntries.includes(item))return false;
 if(!snowJamCatalogReady()||!snowJamAvailableCourses().has(item.courseId)){toast('This SSX course is unavailable. Reopen Worlds to refresh.');return true;}
 showActivity(item);return true;
}
function snowJamOrdinaryMessage(data) {
  if (!data || typeof data !== 'object') return data;
  return {...data,
    ...(data.world ? {world:snowJamOrdinaryWorld(data.world)} : {}),
    ...(Array.isArray(data.worlds) ? {worlds:snowJamOrdinaryWorlds(data.worlds)} : {}),
    ...(Array.isArray(data.players) ? {players:data.players.filter(player => !snowJamSourcePlayer(player))} : {}),
  };
}
function snowJamFailClosed(error) {
  if (!snowJamBoundaryError) {
    snowJamBoundaryError = error instanceof Error ? error : Error(String(error));
    snowJamResetMovement({preservePhysicalInput:false});
    controls?.releasePointer();
    toast(snowJamBoundaryError.message);
    console.error('Snow Jam boundary:', snowJamBoundaryError);
  }
  return true;
}
function snowJamSourceMessage(data) {
  return data?.worldId === 'snowjam' || snowJamSourceWorld(data?.world) || snowJamSourcePlayer(data?.player) ||
    !!data?.snowJam?.activity || (data?.type === 'snowJamActivity' && !!data.activity) ||
    data?.players?.some(player => player.id === state.player?.id && snowJamSourcePlayer(player));
}
// The HTTP leave ACK and its WebSocket broadcast carry the same movement
// receipt. A delayed duplicate must not undo prediction after city ownership
// resumes. Remember only one receipt, and drop it on the first differing self
// snapshot; changed authoritative corrections still use native reconciliation.
let snowJamReturnedState = null, snowJamReplayFence = null;
const snowJamReturnStateFields = ['id','worldId','crossingSeq','lastInputSeq','yaw',
  'velocityX','velocityY','velocityZ','grounded','flying','lastFlightToggleSeq',
  'jumpHeld','coyoteRemaining','jumpBufferRemaining','portalCooldownRemaining'];
function snowJamRememberReturnedState(player) {
  snowJamReturnedState = {position:{...player.position}, values:snowJamReturnStateFields.map(key=>player[key])};
}
function snowJamReconcileCityState(player, authority, time) {
  const fence=snowJamReplayFence;
  if(fence){
    const sameFrame=player.id===fence.id&&player.worldId===fence.worldId&&(player.crossingSeq??0)===fence.crossingSeq;
    if(sameFrame&&Number.isFinite(time)&&time<=fence.serverTime)return player;
    if(!sameFrame||Number.isFinite(time)&&time>fence.serverTime)snowJamReplayFence=null;
  }
  const receipt = snowJamReturnedState;
  if (receipt) {
    const sameFrame = player.id === receipt.values[0] && player.worldId === receipt.values[1] &&
      (player.crossingSeq ?? 0) === (receipt.values[2] ?? 0);
    if (sameFrame && snowJamReturnStateFields.every((key,index)=>authority[key] === receipt.values[index]) &&
        ['x','y','z'].every(axis=>authority.position?.[axis] === receipt.position[axis])) return player;
    snowJamReturnedState = null;
  }
  const next=socketMovementReconciliation.reconcile(player,authority,time);
  if(next!==player&&['x','y','z'].some(k=>next.position[k]!==player.position[k]))snowJamMount?.resetEntryObservation?.(next.position);
  return next;
}
function snowJamObserve(data) {
  try {
    if (data?.code === 'ACCOUNT_CHANGED' || data?.type === 'accountChanged') { snowJamReturnedState = null;snowJamReplayFence=null; remotePresence?.clear(); if (state.player) straddling?.remove('player:' + state.player.id); }
    if(data?.type==='snowJamPresence'||(['activity','activityHistory','chat'].includes(data?.type)&&data.worldId==='snowjam')){snowJamMount?.serverMessage(data);return true;}
    if (snowJamOwnsFrame() && (data?.code === 'ACCOUNT_CHANGED' || data?.type === 'accountChanged')) snowJamResetMovement({preservePhysicalInput:false});
    if (data?.type === 'catalog' && snowJamSourceWorld(data.world)) return true;
    const handled = snowJamMount?.serverMessage(data);
    if (handled === true) {
      if (snowJamSourceMessage(data) && !snowJamOwnsFrame()) return snowJamFailClosed(Error('An unexpected Snow Jam session needs reconciliation. Reload to return safely.'));
      return true;
    }
    if (snowJamSourceMessage(data)) {
      if (snowJamMount && snowJamOwnsFrame()) return true;
      return snowJamFailClosed(Error('An active Snow Jam session needs reconciliation. Reload to return safely.'));
    }
    if (snowJamOwnsFrame() && ['state','welcome','world','crossed','invited','portalSelected','presence','avatarGesture','npcGreeting','activity','activityHistory','effect'].includes(data?.type)) return true;
    return false;
  } catch (error) { return snowJamFailClosed(error); }
}
function snowJamConnection(connected, error) {
  if (!connected) {snowJamReturnedState = null;snowJamReplayFence=null;}
  if (error?.code === 'ACCOUNT_CHANGED') { remotePresence?.clear(); if (state.player) straddling?.remove('player:' + state.player.id); }
  if (!snowJamMount) return;
  try {
    if ((!connected || error?.code === 'ACCOUNT_CHANGED') && snowJamOwnsFrame()) snowJamResetMovement({preservePhysicalInput:false});
    if (error?.code === 'ACCOUNT_CHANGED') {
      state.accountRefreshRequired = true;
      snowJamMount.serverMessage({type:'accountChanged',code:'ACCOUNT_CHANGED'});
    }
    snowJamMount.serverMessage({type:'connection', connected, error});
  }
  catch (failure) { snowJamFailClosed(failure); }
}
function snowJamValidateReturn(receipt, expectedId = state.player?.id) {
  const player = receipt?.player, world = receipt?.world;
  if (receipt?.activity !== null || !player || typeof world?.id !== 'string' || player.worldId !== world.id ||
      snowJamSourceWorld(world) || (expectedId && player.id !== expectedId) ||
      !['x','y','z'].every(axis => Number.isFinite(player.position?.[axis]))) {
    throw Object.assign(Error('The server did not confirm a safe city return. Reload to reconcile this session.'), {code:'SNOWJAM_RETURN_UNCONFIRMED'});
  }
  return {...receipt, player:{...player, position:{...player.position}}, world:snowJamOrdinaryWorld(world)};
}
async function snowJamRecoverBootstrap(data) {
  snowJamInitialStatus = data?.snowJam ?? null;
  if (!snowJamSourceMessage(data)) return snowJamOrdinaryMessage(data);
  if (!snowJamEnabled) throw Object.assign(Error('This browser has an active Snow Jam session but its activity client is disabled. Reopen with the enabled client to return safely.'), {code:'SNOWJAM_CLIENT_DISABLED'});
  // A cold boot never interprets source placeholders as ordinary world geometry.
  // Reconcile through the same authenticated/tab-scoped api; never rewrite worldId.
  let status = await api('/api/activities/snowjam', undefined, 'GET');
  let receipt;
  if (status.activity) {
    try { receipt = await api('/api/activities/snowjam/leave', {activityId:status.activity.activityId}, 'POST'); }
    catch (error) {
      if (error.code) throw error;
      status = await api('/api/activities/snowjam', undefined, 'GET');
      if (status.activity) throw Object.assign(error, {outcomeUncertain:true});
      receipt = status.player && status.world ? status : {...await api('/api/bootstrap', undefined, 'GET'), activity:null};
    }
  } else receipt = status.player && status.world ? status : {...await api('/api/bootstrap', undefined, 'GET'), activity:null};
  const safe = snowJamValidateReturn(receipt, data.player?.id);
  if (safe.snowJam?.activity) throw Error('The activity changed during city recovery. Reload to reconcile safely.');
  snowJamInitialStatus = {...status, activity:null};
  return snowJamOrdinaryMessage({...data, ...safe, snowJam:{...snowJamInitialStatus, activity:null}});
}
function snowJamPreservesEntryInput() {
  return !snowJamBoundaryError && !state.accountRefreshRequired && state.connected !== false && snowJamMount?.preservesEntryInput?.() === true;
}
function snowJamResetMovement({preservePhysicalInput = snowJamPreservesEntryInput()} = {}) {
  snowJamWasFrameOwned ||= snowJamOwnsFrame();
  pendingCameraTraversal.clear();
  const previous = snowJamResetting; snowJamResetting = true;
  try {
    if (!preservePhysicalInput) {
      snowJamWalkingContext = null; snowJamWalkingArmLength = Infinity;
      controls?.clear(); mobileControls?.clear(false); keys.clear();
    }
    movementPrediction.reset(); socketMovementReconciliation.reset();
    // HTTP queues run independently of the animation loop. Discard queued and
    // stale in-flight replies before activity ownership can change spaces.
    httpTransport?.dispose(); httpTransport = null;
    lastSentInput = null; inputTimer = 0; state.near = null; state.waveUntil = 0;
    preferredPortal = null; pendingAtelierPortal = null;
    pendingPresence = null; presenceKey = ''; presenceSentAt = -Infinity;
    cameraArmLength = Infinity;
    renderWorldId = null; renderView = null; traversalQuietUntil = 0;
    seq = Math.max(seq, state.player?.lastInputSeq ?? 0);
    flightToggleSeq = state.player?.lastFlightToggleSeq ?? 0;
    if (state.player) (straddling?.park ?? straddling?.remove)?.call(straddling, 'player:' + state.player.id);
    const interaction = $('#interaction'); if (interaction) interaction.hidden = true;
  } finally { snowJamResetting = previous; }
}
function snowJamSuspendCity() {
  ssxPresentation.enter();
  setComposerMode('chat');
  snowJamReturnedState = null;
  snowJamReturnedCamera?.clear();snowJamReturnedCamera=null;
  if (!snowJamCitySuspended) snowJamCityCamera = {camYaw, camPitch, camDistance};
  snowJamCitySuspended = true;
  setAmbient(false);
  closePanel(); stopPortalPlacement(); composer?.setMenu(false);
  activityDrawer?.collapse();
  // Native minimap collapse releases pointer capture even when already closed.
  // Suppress only this synchronous programmatic collapse during traversal;
  // user clicks/focus loss must still clear held input normally.
  snowJamPreservingMinimapCollapse = snowJamPreservesEntryInput();
  try { worldMinimap.collapse(); } finally { snowJamPreservingMinimapCollapse = false; }
  snowJamResetMovement(); if (!snowJamPreservesEntryInput()) controls?.releasePointer();
  remotePresence?.suspend(state.world?.id, {requestSeq:presenceRequestSeq + 1});
}
function placePortalAvatar(player, quaternion) {
  if (!avatar || !activeView) return;
  activeView.scene.add(avatar.root); avatar.root.position.copy(player.position);
  if (quaternion === undefined) { avatar.root.rotation.y = player.yaw; return; }
  if (!Array.isArray(quaternion) || quaternion.length !== 4 || !quaternion.every(Number.isFinite) || Math.hypot(...quaternion) < 1e-8) throw Error('Finite returned avatar quaternion required');
  // Physical heading can lead the visible turn by several frames. Preserve the
  // actual crossing pose, then let the ordinary city turn easing continue.
  const turn = new T.Euler().setFromQuaternion(new T.Quaternion().fromArray(quaternion).normalize(),'YXZ');
  if (Math.abs(turn.x) + Math.abs(turn.z) < 1e-8) avatar.root.rotation.set(0,turn.y,0);
  else avatar.root.rotation.set(turn.x,turn.y,turn.z,'YXZ');
}
function snowJamApplyCityReturn(receipt, prediction) {
  const safe = snowJamValidateReturn(receipt), returnCamera = snowJamMount?.returnCameraContext?.();
  // Keep ownership suspended until the mount has restored its renderer and
  // returned the borrowed selected avatar. Source coordinates never reach state.
  snowJamCitySuspended = true;
  snowJamResetMovement();
  snowJamRememberReturnedState(safe.player);
  if(prediction){
    if(prediction.id!==safe.player.id||prediction.worldId!==safe.world.id||!['x','y','z'].every(k=>Number.isFinite(prediction.position?.[k])))throw Error('Bound return replay player required');
    safe.player={...prediction,position:{...prediction.position}};
  }
  state.player = safe.player; state.players.clear();
  updatePlayerProfile(safe.player);
  enterWorld(safe.world, false);
  avatar?.customize(safe.player.avatar);
  placePortalAvatar(safe.player, returnCamera?.avatarPose?undefined:returnCamera?.avatarQuaternion);
  if(returnCamera?.avatarAnimation){
    const animation=returnCamera.avatarAnimation;
    if(animation.avatarRoot!==avatar.root||animation.avatarMixer!==avatar.mixer||animation.avatarRevision!==avatar.root.userData.avatarModelRevision)throw Error('Same selected avatar animation handoff required');
    animation.commit();
  }else if(returnCamera?.avatarPose){
    const pose=returnCamera.avatarPose;
    if(pose.avatarRoot!==avatar.root||pose.avatarMixer!==avatar.mixer||pose.avatarRevision!==avatar.root.userData.avatarModelRevision||typeof avatar.adoptPortalPose!=='function')throw Error('Same selected avatar pose handoff required');
    const {sourcePortal,targetPortal,sourceSide,targetSide,headingDelta,sourcePosition}=returnCamera;
    const origin=snowJamPortalMath.transformPortalPoint({x:0,y:0,z:0},sourcePortal,targetPortal,sourceSide,targetSide);
    const mappedFeet=snowJamPortalMath.transformPortalPoint(sourcePosition,sourcePortal,targetPortal,sourceSide,targetSide);
    const matrix=new T.Matrix4().makeRotationY(headingDelta).scale(new T.Vector3(.01,.01,.01));
    matrix.setPosition(origin.x+safe.player.position.x-mappedFeet.x,origin.y+safe.player.position.y-mappedFeet.y,origin.z+safe.player.position.z-mappedFeet.z);
    avatar.adoptPortalPose(pose.bones.map(({object,world})=>({object,world:matrix.clone().multiply(world)})));
  }
  seq = Math.max(seq, safe.player.lastInputSeq ?? 0);
  flightToggleSeq = safe.player.lastFlightToggleSeq ?? 0;
  if (returnCamera) {
    snowJamCityReturnArm = snowJamMapPortalCamera({...returnCamera, player:safe.player, continueCamera:true});
    snowJamCityCamera = null;
  } else {
    snowJamReturnedCamera?.clear();snowJamReturnedCamera=null;
    if (snowJamCityCamera) ({camYaw, camPitch, camDistance} = snowJamCityCamera);
    snowJamCityReturnArm = null;
  }
  cameraArmLength = snowJamCityReturnArm ?? Infinity;
  return safe;
}
function snowJamResumeCity() {
  if (snowJamSourcePlayer(state.player) || snowJamSourceWorld(state.world)) return snowJamFailClosed(Error('City ownership cannot resume before an acknowledged return.'));
  snowJamResetMovement();
  if (snowJamCityCamera) ({camYaw, camPitch, camDistance} = snowJamCityCamera);
  if (snowJamCityReturnArm !== null) {
    cameraArmLength = snowJamCityReturnArm;
    renderView = portals?.setWorld?.(state.world, undefined, {activePortalId:state.player.activePortalId}) ?? activeView;
    renderWorldId = state.world.id;
  }
  snowJamCityReturnArm = null; snowJamCityCamera = null; snowJamBoundaryError = null; snowJamCitySuspended = false;
  ssxPresentation.returned();
  refreshValoriaReturnButton();
  setAmbient(state.sound);
  const returnedAvatar=snowJamMount?.returnCameraContext?.();
  placePortalAvatar(state.player, returnedAvatar?.avatarPose?undefined:returnedAvatar?.avatarQuaternion);
  if (!LOCAL && state.capabilities?.transport === 'http' && !state.accountRefreshRequired) connect();
  if (avatar && portals && !snowJamMount?.ownsLocalContinuation?.()) void straddling.prepare([{id:'player:' + state.player.id,root:avatar.root,world:state.world,activePortalId:state.player.activePortalId,radius:1.2}], portals.getWorlds()).catch(error => console.warn('City avatar preparation:', error.message));
}
// The walking owner borrows the city input and camera implementation. Only its
// player/world and sequence counters are isolated; no packet enters city state,
// prediction, HTTP queues or the socket. Riding keeps its retained source camera.
function snowJamWalkingInputContext() {
  if (!snowJamOwnsFrame()) return null;
  return typeof snowJamMount?.walkingContext === 'function' ? snowJamMount.walkingContext() : snowJamWalkingContext;
}
function snowJamWalkingMobileContext() {
  if (!snowJamOwnsFrame()) return null;
  const context = snowJamWalkingInputContext(), player = context?.player;
  return {flying:player?.flying === true, flightAllowed:!!context && flightAllowed(context.world),
    grounded:player?.grounded !== false, moving:Math.hypot(player?.velocityX || 0, player?.velocityZ || 0) > .35 ||
      [...(controls?.keys ?? [])].some(key => ['w','a','s','d','arrowup','arrowdown','arrowleft','arrowright'].includes(key)),
    placement:null, near:null, panelOpen:!!state.panel||accountAccessPanel?.isOpen===true, menuOpen:!$('#tool-menu').hidden};
}
// Both directions use the same native portal isometry. The supplied camera,
// when present, is a frozen host-metre pose captured at the doorway crossing.
function snowJamMapPortalCamera({sourcePortal, targetPortal, sourceSide = 1, targetSide = 1, headingDelta, camera:sourceCamera = camera, player, deriveOrbit = false, orbit, inputOrbit, sourcePosition, continueCamera=false}) {
  const delta = headingDelta ?? snowJamPortalMath.portalHeadingDelta(sourcePortal, targetPortal, sourceSide, targetSide);
  if (!Number.isFinite(delta)) throw Error('Finite doorway camera heading required');
  const eye = snowJamPortalMath.transformPortalPoint(sourceCamera.position, sourcePortal, targetPortal, sourceSide, targetSide);
  if(continueCamera&&sourcePosition&&player?.position){
    const mapped=snowJamPortalMath.transformPortalPoint(sourcePosition,sourcePortal,targetPortal,sourceSide,targetSide);
    eye.x+=player.position.x-mapped.x;eye.y+=player.position.y-mapped.y;eye.z+=player.position.z-mapped.z;
  }
  const direction = snowJamPortalMath.transformPortalVector(sourceCamera.getWorldDirection(new T.Vector3()), sourcePortal, targetPortal, sourceSide, targetSide);
  // The camera and its orbit controls must come from the same presented
  // source frame. A delayed server response must not replay an older eye.
  if(orbit){
    if(!['camYaw','camPitch','camDistance'].every(key=>Number.isFinite(orbit[key])))throw Error('Finite returned camera orbit required');
    ({camYaw,camPitch,camDistance}=orbit);
    // Pointer events after the last rendered source frame are real queued input.
    // Keep those deltas for the next city frame rather than dropping them.
    if(inputOrbit){camYaw+=inputOrbit.camYaw-orbit.camYaw;camPitch+=inputOrbit.camPitch-orbit.camPitch;camDistance+=inputOrbit.camDistance-orbit.camDistance;}
  }
  camYaw += delta;
  const target = player?.position && {x:player.position.x,y:player.position.y + CAMERA_FRAMING.targetHeight,z:player.position.z};
  const arm = target ? Math.hypot(eye.x - target.x, eye.y - target.y, eye.z - target.z) : Infinity;
  if (deriveOrbit && target) {
    const x = eye.x - target.x, y = eye.y - target.y, z = eye.z - target.z;
    camYaw = Math.atan2(-direction.x,-direction.z);
    camPitch = T.MathUtils.clamp(Math.atan2(-direction.y,Math.hypot(direction.x,direction.z)),CAMERA_FRAMING.minPitch,CAMERA_FRAMING.maxPitch);
    camDistance = T.MathUtils.clamp(arm,minimumCameraDistance(camera.aspect),CAMERA_FRAMING.maxDistance);
  }
  camera.position.set(eye.x,eye.y,eye.z);
  if(deriveOrbit||continueCamera){
    camera.quaternion.copy(sourceCamera.getWorldQuaternion(new T.Quaternion())).premultiply(new T.Quaternion().setFromAxisAngle(new T.Vector3(0,1,0),delta));
    for(const key of ['fov','zoom','near','far','focus','aspect','filmGauge','filmOffset'])camera[key]=sourceCamera[key];
    camera.view=sourceCamera.view?{...sourceCamera.view}:null;
    camera.projectionMatrix.copy(sourceCamera.projectionMatrix);camera.projectionMatrixInverse.copy(sourceCamera.projectionMatrixInverse);
  }else camera.lookAt(eye.x + direction.x,eye.y + direction.y,eye.z + direction.z);
  // A returned/pending eye may retain manually owned matrix flags. Publish
  // the mapped local/world matrices before seeding the next continuation.
  camera.updateMatrix();camera.matrixWorld.copy(camera.matrix);
  camera.matrixWorldInverse.copy(camera.matrixWorld).invert();camera.matrixWorldNeedsUpdate=false;
  snowJamReturnedCamera?.clear();snowJamReturnedCamera=null;
  if(continueCamera&&player){
    // Seed the last published controls, so pointer/zoom events received after
    // that draw remain real deltas for the next native city frame.
    const publishedOrbit=orbit&&!deriveOrbit?{camYaw:orbit.camYaw+delta,camPitch:orbit.camPitch,camDistance:orbit.camDistance}:{camYaw,camPitch,camDistance};
    snowJamReturnedCamera=snowJamMount.createReturnedCameraContinuation({camera,playerPosition:player.position,orbit:publishedOrbit,targetHeight:CAMERA_FRAMING.targetHeight});
    snowJamReturnedCameraAspect=camera.aspect;snowJamReturnedCameraPortal=targetPortal;
  }
  return arm;
}
function snowJamCreateWalkingControls() {
  const isolated = {seq:0, flightToggleSeq:0, player:null, world:null};
  const setContext = context => {
    snowJamWalkingContext = context?.player && context?.world ? context : null;
    if (snowJamWalkingContext) {
      isolated.player = context.player; isolated.world = context.world;
      isolated.seq = Math.max(isolated.seq, context.player.lastInputSeq ?? 0, context.player.lastFlightToggleSeq ?? 0);
      isolated.flightToggleSeq = Math.max(isolated.flightToggleSeq, context.player.lastFlightToggleSeq ?? 0);
    } else {
      isolated.player = null; isolated.world = null; isolated.seq = 0; isolated.flightToggleSeq = 0;
      snowJamWalkingArmLength = Infinity; snowJamWalkingTraversal = null;
      snowJamWalkingCamera?.clear(); snowJamWalkingCamera=null;
    }
  };
  return Object.freeze({
    setContext,
    rebaseInput(player){isolated.seq=Math.max(seq,player.lastInputSeq??0,player.lastFlightToggleSeq??0);isolated.flightToggleSeq=Math.max(flightToggleSeq,player.lastFlightToggleSeq??0);return {sourceInputSeq:isolated.seq,sourceFlightToggleSeq:isolated.flightToggleSeq};},
    onEnter(context) { setContext(context); snowJamWalkingArmLength = Infinity; },
    enterPortal(context) {
      snowJamWalkingTraversal = context;
      snowJamWalkingArmLength = snowJamMapPortalCamera({...context,continueCamera:true});
      snowJamWalkingCamera?.clear();snowJamWalkingCamera=snowJamReturnedCamera;snowJamReturnedCamera=null;
      snowJamWalkingCameraAspect=camera.aspect;
      if (context.player && context.world) setContext({player:context.player,world:context.world});
    },
    returnPortal(context) {
      const arm = snowJamMapPortalCamera(context); setContext(null); return arm;
    },
    clear() { snowJamWalkingCamera?.clear();snowJamWalkingCamera=null; snowJamWalkingContext = null; snowJamWalkingArmLength = Infinity; snowJamWalkingTraversal = null; isolated.seq = 0; isolated.flightToggleSeq = 0; },
    sample({dt = 0, player, world, sequenceContext}) {
      if(sequenceContext){
        const sourceSeq=sequenceContext.sourceInputSeq,sourceToggle=sequenceContext.sourceFlightToggleSeq;
        if(!Number.isSafeInteger(sourceSeq)||!Number.isSafeInteger(sourceToggle)||sourceSeq<sourceToggle||sourceToggle<0)throw Error('Native source input baseline required');
        player={...player,lastInputSeq:sourceSeq,lastFlightToggleSeq:sourceToggle};
        isolated.seq=sourceSeq;isolated.flightToggleSeq=sourceToggle;
      }
      setContext({player,world});
      if (!snowJamWalkingContext) throw Error('Walking requires its own Valoria player and world');
      const touch = combinedTouch();
      camYaw -= (touch.lookX || 0) * dt * 2.15;
      camPitch = T.MathUtils.clamp(camPitch + (touch.lookY || 0) * dt * 1.6, CAMERA_FRAMING.minPitch, CAMERA_FRAMING.maxPitch);
      mobileControls?.updateContext();
      const flightHint = $('#flight-hint'), flightHelp = player.flying ? 'Up · C down · Shift boost' : flightAllowed(world) ? 'Jump · double-tap to fly' : 'Jump';
      if (flightHint && flightHint.textContent !== flightHelp) { flightHint.textContent = flightHelp; flightHint.title = player.flying ? 'Double-tap Space within 450 ms to stop flying' : ''; }
      return input(touch, isolated);
    },
    onLook(dx,dy) {
      camYaw -= dx * 22e-4;
      camPitch = T.MathUtils.clamp(camPitch + dy * 22e-4, CAMERA_FRAMING.minPitch, CAMERA_FRAMING.maxPitch);
    },
    onZoom(dy) { camDistance = T.MathUtils.clamp(camDistance + dy * 6e-3, minimumCameraDistance(camera?.aspect), CAMERA_FRAMING.maxDistance); },
    camera:Object.freeze({
      hostCamera:camera, yaw:() => camYaw, snapshotOrbit(out={}){out.camYaw=camYaw;out.camPitch=camPitch;out.camDistance=camDistance;return out;},
      update(position, {dt = 0, player, world, colliders, cameraColliders, collisionEnvironment, view} = {}) {
        const contextPlayer = player ?? view?.player, contextWorld = world ?? view?.world;
        if (contextPlayer && contextWorld) setContext({player:contextPlayer,world:contextWorld});
        if(snowJamWalkingCamera&&camera.aspect!==snowJamWalkingCameraAspect){snowJamWalkingCamera.adoptLens(camera);snowJamWalkingCameraAspect=camera.aspect;}
        const orbit = snowJamWalkingCamera?.update({playerPosition:position,orbit:{camYaw,camPitch,camDistance}}) ?? viewCameraPose(position);
        const query = cameraColliders ?? collisionEnvironment?.cameraColliders ?? view?.cameraColliders;
        const boxes = typeof query === 'function' ? query(orbit.target, orbit.desired) :
          typeof colliders === 'function' ? colliders(orbit.target, orbit.desired) : colliders ?? [];
        const environment = collisionEnvironment ?? view?.collisionEnvironment;
        const routed=snowJamMount?.routeCourseCamera?.({camera,target:orbit.target,desired:orbit.desired,playerPosition:position,collisionEnvironment:environment,cameraColliders:query,dt,previousDistance:snowJamWalkingArmLength,cameraContinuation:snowJamWalkingCamera});
        if(routed?.handled){snowJamWalkingArmLength=routed.distance;return;}
        let desired = orbit.desired, courseDesired = desired, trailing = false;
        if (snowJamWalkingTraversal) {
          const traversal = snowJamWalkingTraversal, source = traversal.sourcePortal, destination = snowJamPortalMath.portalEntryFrame(traversal.targetPortal,traversal.targetSide??1);
          const sourceId = source.id ?? source.portalId, targetId = destination.id ?? destination.portalId;
          const sourceWorldId = traversal.sourceWorldId ?? source.worldId ?? 'valoria';
          const cityWorld = {id:sourceWorldId,portals:[{...source,id:sourceId,targetWorldId:'snowjam',targetPortalId:targetId}]};
          const courseWorld = {id:'snowjam',portals:[{...destination,id:targetId,targetWorldId:sourceWorldId,targetPortalId:sourceId}]};
          const receipt = {sourceWorldId,targetWorldId:'snowjam',sourcePortalId:sourceId,targetPortalId:targetId,sourceSide:traversal.sourceSide??1,targetSide:1};
          const route = routeCameraThroughPortal(courseWorld,new Map([[sourceWorldId,cityWorld],['snowjam',courseWorld]]),orbit.target,desired,targetId,()=>true,receipt);
          if (route.crossing && route.world.id === sourceWorldId) { courseDesired = route.crossing.intersection; trailing = true; }
          else if (!route.traversalActive) snowJamWalkingTraversal = null;
        }
        if (typeof environment?.cameraClearance === 'function') {
          const allowed = environment.cameraClearance(orbit.target, courseDesired);
          if (!Number.isFinite(allowed) || allowed < 0) throw Error('Invalid course camera clearance');
          const x = courseDesired.x - orbit.target.x, y = courseDesired.y - orbit.target.y, z = courseDesired.z - orbit.target.z;
          const length = Math.hypot(x,y,z), fraction = length > 0 ? Math.min(1,allowed / length) : 0;
          // Only the course-side segment can collide with course terrain. Native
          // routing owns the remaining arm in the city and clamps its AABBs.
          if (!trailing || allowed + .08 < length) desired = {x:orbit.target.x + x * fraction, y:orbit.target.y + y * fraction, z:orbit.target.z + z * fraction};
        }
        const arm = clampCameraArm(orbit.target, desired, boxes, snowJamWalkingArmLength, dt);
        snowJamWalkingArmLength = arm.distance;
        camera.position.set(arm.x, arm.y, arm.z);
        if(snowJamWalkingCamera)snowJamWalkingCamera.applyCamera(camera,camera.position);
        else camera.lookAt(orbit.target.x, orbit.target.y, orbit.target.z);
        camera.updateMatrixWorld(true);
      },
    }),
  });
}
// The ordinary city renderer does not register the private source world. Its
// local wall clamp may therefore shorten a returned eye before this late pass.
// Use the native unclamped orbit and retain its full arm for the clear-eye frame.
function snowJamReturnedOrbit(playerPosition) {
  if(!snowJamReturnedCamera)return null;
  if(camera.aspect!==snowJamReturnedCameraAspect){snowJamReturnedCamera.adoptLens(camera);snowJamReturnedCameraAspect=camera.aspect;}
  const pose=snowJamReturnedCamera.update({playerPosition,orbit:{camYaw,camPitch,camDistance}});

  return pose;
}
function snowJamApplyReturnedCamera(route) {
  if(!snowJamReturnedCamera)return;
  const crossing=route?.crossing,headingDelta=route?.cameraHeadingDelta??(crossing?snowJamPortalMath.portalHeadingDelta(crossing.source,crossing.target,crossing.sourceSide,crossing.targetSide):0);
  snowJamReturnedCamera.applyCamera(camera,camera.position,{headingDelta});
}
function snowJamRenderReturnedFrame(dt,nativeRoute,previousDistance) {
  if(nativeRoute?.pendingBodyTraversal)return false;
  const rendered=snowJamMount?.renderCityFrame?.(camera,{dt,time:state.time,player:state.player,cameraDesired,cameraTarget,cameraContinuation:xrPresentation?.active()||hostViewIsTransitioning()?null:snowJamReturnedCamera,nativeRoute,previousDistance}) === true;
  const presentation=snowJamMount?.cityCameraPresentation?.();
  if(presentation?.camera&&(rendered||presentation.sourceOnly)){
    const published=presentation.camera;
    for(const key of ['position','quaternion','scale','up','projectionMatrix','projectionMatrixInverse'])camera[key].copy(published[key]);
    for(const key of ['fov','zoom','near','far','focus','aspect','filmGauge','filmOffset'])camera[key]=published[key];
    camera.view=published.view?{...published.view}:null;publishNativeCamera(camera);
    cameraArmLength=presentation.distance;
    if(!rendered&&renderWorldId!==state.world.id){renderView=portals.setWorld(state.world,undefined,{activePortalId:state.player.activePortalId});renderWorldId=state.world.id;}
    return rendered;
  }
  if(!rendered)return false;
  if(snowJamReturnedCamera&&!xrPresentation?.active()&&!hostViewIsTransitioning())snowJamReturnedCamera.applyCamera(camera,cameraDesired);
  else {camera.position.copy(cameraDesired);camera.lookAt(cameraTarget);}
  camera.updateMatrixWorld(true);
  cameraArmLength = cameraDesired.distanceTo(cameraTarget);
  return true;
}
async function snowJamInstall() {
  if (!snowJamEnabled) {
    if(snowJamDirectRoute)throw Error('SSX mode is unavailable on this server. Return to the main game or try again later.');
    return;
  }
  const snowJamSource = await import('./snowjam/client-mount.mjs');
  const {mountSnowJamClient} = snowJamSource;
  let workerServices;
  if (ssxWorkerRequested(window.location.search)) {
    try {
      const {createBrowserWorkerServices} = await import('./ssx-browser-worker-services.mjs');
      workerServices = createBrowserWorkerServices({source:snowJamSource,api,getState:()=>state,location:window.location,workerURL:new URL('./ssx-source-worker.js',import.meta.url),onBootFallback:error=>console.warn('SSX worker boot unavailable; using original source owner.',error)});
    } catch (error) {
      // No worker/session exists here. Do not catch mount or active-owner failures.
      console.warn('SSX worker setup unavailable; using original source owner.',error);
    }
  }
  snowJamMount = await mountSnowJamClient({
    ...(workerServices ? {services:workerServices} : {}),
    getViewMode:()=>viewPreference.get(),getStandingEye:standingAvatarEye,prepareView:camera=>xrPresentation?.prepare(camera),getXRInput:()=>xrPresentation?.input()||{},getControllerInput:()=>controllerSample,
    THREE:T, portalModule:snowJamPortalModule, portalMath:snowJamPortalMath,
    createPortalStraddling,warmupObject:request=>portals.warmupObject(request),
    removeNativeContinuation:()=>{if(state.player)(straddling.park??straddling.remove).call(straddling,'player:'+state.player.id);},
    cameraRouting:{routeCameraThroughPortal,worldColliders,clampCameraArm,portalHeadingDelta:snowJamPortalMath.portalHeadingDelta,portalEntryFrame:snowJamPortalMath.portalEntryFrame,targetHeight:CAMERA_FRAMING.targetHeight}, renderer, viewport:$('#experience'), camera, api,
    getState:() => state, getAvatar:() => avatar, getCityView:() => activeView,
    directEntryRequested:snowJamDirectRoute,
    getDirectEntryReady:()=>!state.accountRefreshRequired && !state.panel && !accountAccessPanel?.isOpen && !needsProfileSetup(state.player,{local:LOCAL,capabilities:state.capabilities,account:state.account}),
    getPortalCityView:(worldId)=>worldId&&activeView?.world?.id!==worldId?portals.getWorldView(worldId):activeView,
    prepareDirectCityView:async({signal,worldId='valoria'}={})=>{
      if(!snowJamDirectRoute)return;
      const check=()=>{if(signal?.aborted)throw signal.reason??Error('Snow Jam preparation cancelled');};check();
      // The ordinary resolver also starts spawn-map work after its fetch. Keep
      // this bounded warmup read separate so a late response cannot do that
      // work after arrival has already fallen back to the city.
      let city=worldCache.get(worldId);
      if(!city){const response=await api(`/api/worlds/${encodeURIComponent(worldId)}`,undefined,'GET');check();city=snowJamOrdinaryWorld(response.world??response);}
      check();await prepareSpawnSafety(city,{yieldTask:()=>new Promise((resolve,reject)=>setTimeout(()=>{try{check();resolve();}catch(error){reject(error);}},0))});
      check();worldCache.set(worldId,city);portals.registerWorld(city);
    },
    createRemoteAvatar:config=>createAvatar(config),
    onCourseActivity:message=>{if(!snowJamOwnsFrame()||message.worldId!=='snowjam')return;publicActivity.reset('snowjam');if(publicActivity.apply(message))renderPublicActivity();},
    controls:{clear:() => controls?.clear(),releasePointer:() => controls?.releasePointer()},
    walkingControls:snowJamCreateWalkingControls(),
    nativeMobileControls:{root:$('#mobile-controls'),clear:()=>mobileControls?.clear(false),updateContext:()=>mobileControls?.updateContext()},
    getInputBlocked:()=>!!state.panel||accountAccessPanel?.isOpen===true||!$('#tool-menu').hidden||$('#world-minimap')?.classList?.contains('expanded')===true,
    resetMovement:snowJamResetMovement, applyCityReturn:snowJamApplyCityReturn,
    returnReplayTransport:{open(){
      const socket=state.socket,identity=state.player?.accountId??state.player?.id;
      if(state.capabilities?.transport==='http'||socket?.readyState!==1||state.connected===false||state.accountRefreshRequired)return null;
      let closed=false;return Object.freeze({send(packet){
        if(closed||state.socket!==socket||socket.readyState!==1||identity!==(state.player?.accountId??state.player?.id)||state.accountRefreshRequired)throw Error('Return replay connection changed');
        if(!['snowJamReturnReplay','input'].includes(packet?.type))throw Error('Bound return movement packet required');
        socket.send(JSON.stringify(packet));return true;
      },close(){closed=true;}});
    }},
    applyCityRollback(player){
      if(player?.id!==state.player?.id||snowJamSourceWorld(state.world)||player.worldId!==state.world?.id)throw Error('Same city identity required for local rollback');
      state.player={...player,position:{...player.position}};movementPrediction.reset();socketMovementReconciliation.reset();lastSentInput=null;inputTimer=0;
    },
    finishReturnReplay({player,endpoint,serverTime,camera:presented,portal,arm,orbit,preserveInput}){
      snowJamResetMovement({preservePhysicalInput:preserveInput===true});
      if(endpoint){snowJamRememberReturnedState(endpoint);if(Number.isFinite(serverTime))snowJamReplayFence={id:player.id,worldId:player.worldId,crossingSeq:player.crossingSeq??0,serverTime};}
      seq=Math.max(player.lastInputSeq??0,player.lastFlightToggleSeq??0);flightToggleSeq=player.lastFlightToggleSeq??0;
      publishNativeCamera(camera,()=>camera.copy(presented,false));
      snowJamReturnedCamera?.clear();snowJamReturnedCamera=snowJamMount.createReturnedCameraContinuation({camera,playerPosition:player.position,orbit:orbit??{camYaw,camPitch,camDistance},targetHeight:CAMERA_FRAMING.targetHeight});
      snowJamReturnedCameraAspect=camera.aspect;snowJamReturnedCameraPortal=portal;
      cameraArmLength=Number.isFinite(arm)?arm:Math.hypot(camera.position.x-player.position.x,camera.position.y-player.position.y-CAMERA_FRAMING.targetHeight,camera.position.z-player.position.z);
      renderView=activeView;renderWorldId=state.world.id;
    },
    applyReturnReplayPlayer(player){
      if(player?.id!==state.player?.id||snowJamSourceWorld(state.world)||player.worldId!==state.world?.id)throw Error('Acknowledged city identity required for replay');
      state.player={...player,position:{...player.position}};
      seq=Math.max(player.lastInputSeq??0,player.lastFlightToggleSeq??0);flightToggleSeq=player.lastFlightToggleSeq??0;
    },
    config:snowJamConfig, initialStatus:snowJamInitialStatus, onError:error => toast(error.message ?? String(error)),
    onSuspendCity:snowJamSuspendCity, onResumeCity:snowJamResumeCity,
  });
  if (!snowJamMount || typeof snowJamMount.tick !== 'function' || typeof snowJamMount.ownsFrame !== 'function' || typeof snowJamMount.serverMessage !== 'function' || typeof snowJamMount.renderCityPortals !== 'function') throw Error('Snow Jam client ownership contract is incomplete.');
  // Only asset/scene/avatar binding warmup is awaited here. Onboarding and
  // direct-route admission advance from native frames after boot starts RAF.
  await snowJamMount.prepareInitial?.();
  snowJamConnection(state.connected);
}
function snowJamFrameDiagnostics() {
  const portal=snowJamMount?.diagnostics?.().portal;
  return portal ? {snowJamPortalTargetAllocations:portal.targetAllocations,snowJamPortalPoolBytes:portal.poolBytes,snowJamPortalTargetPixels:portal.targetPixels} : {};
}
function snowJamAdvanceFrame(dt, time) {
  if (snowJamBoundaryError) return true;
  if (!snowJamMount) return snowJamCitySuspended;
  try {
    const owned = snowJamMount.tick({dt,time}) === true || snowJamOwnsFrame();
    if (owned && !snowJamWasFrameOwned) snowJamResetMovement();
    if (!owned && snowJamWasFrameOwned && !LOCAL && state.capabilities?.transport === 'http' && !httpTransport && !state.accountRefreshRequired) connect();
    snowJamWasFrameOwned = owned;
    if (owned) {
      const navigation = snowJamMount.navigationSnapshot?.();
      if (navigation) worldMinimap.update({...navigation,time});
      snowJamRenderMenuPreview(dt);
      if (snowJamMount.status?.().renderedCourse === true) arrivalTransition?.rendered({assetsReady:true});
    }
    return owned;
  } catch (error) { return snowJamFailClosed(error); }
}
// END SNOWJAM CLIENT BOUNDARY

let arrivalTransition;
const worldMinimap=createWorldMinimap({root:$('#hud-base'),releasePointer:()=>{if(!snowJamPreservingMinimapCollapse)controls?.releasePointer();},onPortal:id=>{if(snowJamMount?.locatePortal(id))return;const portal=state.world?.portals?.find(p=>p.id===id);if(portal){selectPortal(portal);toast(`Follow the highlighted portal to ${portal.label??portal.targetWorldId}.`);}},onDirectory:()=>openPanel('worlds')});
let pendingPresence = null, presenceRequestSeq = 0, presenceKey = "", presenceSentAt = -Infinity;
// A later unrelated save cannot confirm an earlier uncertain operation. Keep the
// warning until a fresh document obtains authoritative state; never replay here.
let pendingPersistenceNotice=null;
function persistenceFeedback(data) {
  const persistence=data?.persistence;
  if(persistence?.status==='outcome-unknown'||data?.code==='PERSISTENCE_OUTCOME_UNKNOWN'||((data?.publicationError===true||data?.code==='STATE_PUBLICATION_RECOVERY_REQUIRED')&&persistence?.committed!==true))return {rank:4,message:'The change could not be confirmed. It may have been applied. Reload to check before submitting it again.'};
  if(data?.publicationError===true||data?.code==='STATE_PUBLICATION_RECOVERY_REQUIRED')return {rank:3,message:'A change was committed, but its visible result needs confirmation. Reload to check before submitting it again.'};
  if(persistence?.status==='visible-durability-unknown')return {rank:2,message:'A change was accepted, but saving is still unconfirmed. Reload to check before submitting it again.'};
  if(data?.notificationError===true)return {rank:1,message:'A change was accepted, but updates to other views are pending. Reload to check its current state.'};
  if(data?.session?.persistent===false)return {rank:1,message:'Saving is not confirmed for this session. Reload to check before submitting changes again.'};
  return null;
}
function observePersistence(data) {
  const notice=persistenceFeedback(data);
  if(notice&&(!pendingPersistenceNotice||notice.rank>=pendingPersistenceNotice.rank)){
    const changed=notice.message!==pendingPersistenceNotice?.message;
    pendingPersistenceNotice=notice;
    if(changed)toast(notice.message);
  }
  return notice;
}
function toast(text) {
  $("#toast").textContent = text;
  $("#toast").hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    // The legacy save-status node is hidden. Keep uncertainty visible in the
    // existing accessible toast without stealing focus or blocking controls.
    $("#toast").textContent=pendingPersistenceNotice?.message??'';
    $("#toast").hidden=!pendingPersistenceNotice;
  }, 4600);
}
function creationPersistenceText(text) {
  return pendingPersistenceNotice&&/^(Saved\.|Request saved\.)/.test(text)?pendingPersistenceNotice.message:text;
}
function persistenceError(data,status) {
  const notice=observePersistence(data);
  return Object.assign(Error(notice?.message||data?.error||data?.message||'The change could not be saved.'),{
    code:data?.code??(data?.persistence?.status==='outcome-unknown'?'PERSISTENCE_OUTCOME_UNKNOWN':undefined),status,
    ...(data?.persistence?{persistence:data.persistence}:{}),
    ...(data?.publicationError?{publicationError:true}:{}),...(data?.notificationError?{notificationError:true}:{}),
  });
}
function unconfirmedMutation(error) {
  const failure=persistenceError({code:'PERSISTENCE_OUTCOME_UNKNOWN',persistence:{status:'outcome-unknown',committed:null,durable:false}});
  failure.cause=error;return failure;
}
function persistenceMutation(path,method) {
  // Frame input and presence retain their existing sequenced recovery policy.
  // This only labels lost outcomes for user actions, and never retries them.
  return !['GET','HEAD'].includes(method.toUpperCase())&&([
    '/api/avatar','/api/portal-pairs','/api/portal-placements','/api/activities/snowjam/doorways',
    '/api/play-sessions','/api/import-local','/api/creation-jobs',
    '/api/public-world/resort','/api/worlds',
    '/api/owner-creation/cancel',
    '/api/friend-invites/join','/api/return-valoria','/api/interact','/api/chat','/api/portal-selection',
  ].includes(path)||/^\/api\/worlds\/[^/?#]+\/patch$/.test(path));
}
let traversalQuietUntil=0;
const localSaver=createDeferredPersistence({
  serialize:()=>JSON.stringify({player:{...state.player,avatar:state.player.avatar},worlds:state.localWorlds}),
  write:value=>localStorage.setItem("valoria-reality-v1",value),
  isBusy:()=>performance.now()<traversalQuietUntil||(Math.hypot(state.player?.velocityX??0,state.player?.velocityZ??0)>.05),
  onResult:error=>{lastLocalSaveError=error;$("#save-status").textContent=error?"Device storage unavailable":"Saved on this device";},
});
function persist() {if(LOCAL)localSaver.request();}
addEventListener("pagehide",()=>{if(LOCAL)localSaver.flush({force:true});});
document.addEventListener("visibilitychange",()=>{diagnostics.event(document.hidden?"document-hidden":"document-visible");if(LOCAL&&document.hidden)localSaver.flush({force:true});});
// Per-document identity deliberately avoids sessionStorage, which browser Duplicate Tab copies.
const presenceTabId=crypto.randomUUID();
async function api(path, body, method = body ? "POST" : "GET", {signal} = {}) {
  if(state.accountRefreshRequired)throw Object.assign(Error("Your sign-in changed. Reload to continue."),{code:"ACCOUNT_CHANGED"});
  const mutation=persistenceMutation(path,method);
  let res;
  try {res = await fetch(path, { method, signal, ...(path.startsWith("/api/owner-creation/")?{redirect:"error",referrerPolicy:"no-referrer",cache:"no-store"}:{}), credentials: "same-origin", headers: {"X-Valoria-Tab":presenceTabId,...(body ? { "Content-Type": "application/json" } : {})}, body: body ? JSON.stringify(body) : void 0 });}
  catch(error){if(state.accountRefreshRequired)throw Object.assign(Error("Your sign-in changed. Reload to continue."),{code:"ACCOUNT_CHANGED"});throw mutation?unconfirmedMutation(error):error;}
  let data;
  try {
    data = await res.json();
  } catch(error) {
    if(state.accountRefreshRequired)throw Object.assign(Error("Your sign-in changed. Reload to continue."),{code:"ACCOUNT_CHANGED"});
    throw mutation?unconfirmedMutation(error):Error("World service is unavailable. Please reconnect.");
  }
  if(state.accountRefreshRequired)throw Object.assign(Error("Your sign-in changed. Reload to continue."),{code:"ACCOUNT_CHANGED"});
  observePersistence(data);
  if (!res.ok||data?.persistence?.status==='outcome-unknown'||data?.publicationError===true)throw persistenceError(data,res.status);
  return data;
}
function repairLocalPosition() {
  let result = sanitizePlayerPosition(state.player, state.world);
  if (result.blocked) {
    state.world = state.localWorlds.valoria;
    result = sanitizePlayerPosition({ ...state.player, position: null }, state.world);
  }
  if (result.blocked) throw Error("No safe arrival is available.");
  state.player = { ...result.player, worldId: state.world.id };
  return result.repaired;
}
function summaries() {
  return Object.values(state.localWorlds).map((w) => ({ id: w.id, name: w.name, description: w.description, ownerId: w.ownerId, revision: w.revision, flightAllowed:flightAllowed(w), theme: w.theme }));
}
async function boot() {
  if (LOCAL) {
    let saved;
    try {
      saved = JSON.parse(localStorage.getItem("valoria-reality-v1"));
    } catch {
    }
    state.localWorlds = saved?.worlds || createSeedWorlds({ gardenPatch: moonwater, cityColliders: CITY_COLLIDERS });
    normalizeWorldPortalLinks(state.localWorlds);
    normalizeSystemWorldGeometry(state.localWorlds, CITY_COLLIDERS);
    state.player = saved?.player || { id: "local-" + crypto.randomUUID().slice(0, 8), name: "Wanderer", avatar: { ...DEFAULT_AVATAR }, worldId: "valoria", position: { x: 0, y: 0, z: 30 }, yaw: Math.PI };
    state.world = state.localWorlds[state.player.worldId] || state.localWorlds.valoria;
    repairLocalPosition();
    state.worlds = summaries();
    state.connected = true;
    $("#mode-note").hidden = true;
  } else {
    const data = await snowJamRecoverBootstrap(await arrivalRecovery.load());
    Object.assign(state, { region:data.region??createDefaultRegion(), player: data.player, world: data.world, worlds: data.worlds, capabilities: data.capabilities??{}, account:data.account??{}, ownerCreationSession:data.ownerCreationSession??null, catalogRevision:data.catalogRevision });
    seq=Math.max(seq,state.player.lastInputSeq??0,state.player.lastFlightToggleSeq??0);
    connect();
  }
  $("#profile-name").textContent = profileLabel(state.player);
  await setupScene();
  if (!await loadAvatars(state.player.avatar?.preset ?? "female")) throw Error("Your avatar could not load. Reload to retry.");
  avatar = createAvatar(state.player.avatar);
  enterWorld(state.world, false);
  await portals.preload(state.world, {waitForDeferred: true});
  await Promise.all([...portals.getWorlds().values()].map(world=>prepareSpawnSafety(world)));
  await straddling.prepare([{id:`player:${state.player.id}`,root:avatar.root,world:state.world,activePortalId:state.player.activePortalId,radius:1.2}],portals.getWorlds());
  if (pendingPresence) { remotePresence.applySnapshot(pendingPresence); pendingPresence = null; }
  if(!LOCAL&&state.capabilities?.creationQueue){try{state.creations=(await api("/api/creations")).creations??[];}catch{state.creations=[];}}
  bindUI();
  await snowJamInstall();
  setupLiveContent();
  offerLocalImport();
  if (!portals.isReady(state.world.id)) throw Error("Your world could not load. Reload to retry.");
  arrivalTransition = createArrivalTransition({loading: $("#loading")});
  if(new URLSearchParams(location.search).get("diagnostics")==="1")diagnostics.start();
  renderer.setAnimationLoop(tick);
  accountReturnStatus=consumeAccountReturn();
  if(accountReturnStatus)accountAccessPanel.open();
  else if(needsProfileSetup(state.player,{local:LOCAL,capabilities:state.capabilities,account:state.account}))openPanel('onboarding');
  else if(pendingInviteToken!==null)openPanel('join-invite');
  else if(suggestedProfileName(location.search))openPanel('profile-edit');
}
function updatePlayerProfile(snapshot) {
  applyProfileSnapshot(state.player,snapshot);
  $("#profile-name").textContent=profileLabel(state.player);
  refreshNavigation();
  if(state.account?.kind==='authenticated'&&snapshot.username!==undefined)state.account={...state.account,username:snapshot.username,needsUsername:!snapshot.username};
}
function reconcileHttpPlayer(authoritative, world, reset=false) {
  if (snowJamObserve({type:"state",player:authoritative,world,inputReset:reset})) return;
  world = snowJamOrdinaryWorld(world);
  if(world){worldCache.set(world.id,world);portals?.registerWorld(world);}
  const player=movementPrediction.reconcile(state.player,authoritative,world??state.world,{reset,worlds:portals?.getWorlds()});
  const changed=state.world.id!==player.worldId;
  state.player=player;
  snowJamMount?.resetEntryObservation?.(player.position);
  updatePlayerProfile(authoritative);
  camYaw+=movementPrediction.headingDelta;
  preferredPortal=player.activePortalId;
  const currentWorld=portals?.getWorld(player.worldId)??worldCache.get(player.worldId);
  if(changed||(currentWorld&&currentWorld.revision!==state.world.revision))enterWorld(currentWorld,false);
  avatar?.customize(player.avatar);
}
let lastValoriaReturnReceipt=null;
function handleServerMessage(d) {
    if(d.type==='returnedValoria'){if(d.player?.id!==state.player?.id||d.world?.id!=='valoria'||d.player?.worldId!=='valoria'||d.requestId===lastValoriaReturnReceipt)return;lastValoriaReturnReceipt=d.requestId;}
    const notice=observePersistence(d);
    if(notice&&(d.type==='error'||d.persistence?.status==='outcome-unknown'||d.publicationError===true))d={...d,type:'error',message:notice.message,error:notice.message};
    if (snowJamObserve(d)) return;
    if (snowJamSourceWorld(d.world)) return;
    d = snowJamOrdinaryMessage(d);
    if (d.type === "activity" || d.type === "activityHistory") {
      publicActivity.reset(state.world?.id);if(publicActivity.apply(d))renderPublicActivity();
    } else if (d.type === "presence") {
      if (remotePresence) remotePresence.applySnapshot(d);
      else pendingPresence = d;
    } else if (d.type === "world") {
      if((worldCache.get(d.world.id)?.revision??-1)>d.world.revision)return;
      worldCache.set(d.world.id, d.world);
      if (d.world.id === state.world?.id) {
        if (d.player) { if(state.capabilities?.transport === 'http')reconcileHttpPlayer(d.player,d.world);else {pendingCameraTraversal.clear();socketMovementReconciliation.reset();state.player={...state.player,...d.player};} }
        if(d.world.id===state.player.worldId)enterWorld(d.world, false);
      } else portals?.registerWorld(d.world);
    } else if (d.type === "invited" || d.type === "returnedValoria") {
      pendingCameraTraversal.clear();
      controls?.clear();movementPrediction.reset();socketMovementReconciliation.reset();state.player={...state.player,...d.player};preferredPortal=null;presenceKey='';state.near=null;cameraArmLength=Infinity;inputTimer=.1;worldCache.set(d.world.id,d.world);enterWorld(d.world,false);if(avatar)avatar.root.rotation.y=state.player.yaw;$('#interaction').hidden=true;
    } else if (d.type === "crossed") {
      crossWorld(d);
    } else if (d.type === "portalSelected") {
      preferredPortal = d.portalId;
      state.player.activePortalId = d.portalId;
    } else if (d.type === "npcGreeting") { remotePresence?.greet(d); }
    else if(d.type === 'avatarGesture'){remotePresence?.gesture(d,state.player?.worldId);}
    else if (d.type === "notice") toast(d.text);
    else if (d.type === "catalog") {
      state.worlds = state.worlds.filter((w) => w.id !== d.world.id).concat(d.world);
      if(state.panel==="worlds")directoryPanel("worlds");
    } else if (d.type === "welcome" || d.type === "state") {
      if(d.inputReset===true){pendingCameraTraversal.clear();socketMovementReconciliation.reset();}
      if (d.type === "state" && d.player && state.capabilities?.transport === 'http') {
        reconcileHttpPlayer(d.player,d.world??portals?.getWorld(d.player.worldId)??worldCache.get(d.player.worldId),d.inputReset===true);
        return;
      }
      if (d.player && d.type === "welcome") {
        pendingCameraTraversal.clear();
        socketMovementReconciliation.reset();
        const changed = d.player.worldId !== state.player?.worldId;
        state.player = { ...state.player, ...d.player };
        updatePlayerProfile(d.player);
        if (changed && d.world) enterWorld(d.world, false);
      }
      if (d.world && d.world.id !== state.world?.id) enterWorld(d.world, false);
      if (d.worldId !== state.world?.id) return;
      state.players = new Map((d.players || []).map((p) => [p.id, p]));
      const self = state.players.get(state.player.id);
      if (self && state.capabilities?.transport === 'http') {
        reconcileHttpPlayer(self,state.world,d.inputReset===true);
        state.player.avatar = self.avatar;
        avatar?.customize(self.avatar);
      } else if (self) {
        state.player=snowJamReconcileCityState(state.player,self,d.time);
        avatar?.customize(self.avatar);
      }
      if(self){updatePlayerProfile(self);avatar?.customize(self.avatar);}
    } else if (d.type === "effect") {
      if (d.kind === "resonance" || d.note) {
        playNote(d.note);
        entities?.pulse(d.entityId);
      }
      if (d.text) toast(d.text);
    } else if (d.type === "error") {
      if (d.code === "INVALID_PRESENCE_INTEREST" || d.code === "PRESENCE_RATE_LIMIT") presenceKey = "";
      else toast(d.message || d.error || "That action is unavailable.");
    }
    else if (d.type === "chat") addConversation(d.text,{name:d.name,scope:'chat'});
}
function connect() {
  if(state.accountRefreshRequired)return;
  if(state.capabilities?.transport==='http'){
    httpTransport?.dispose();
    httpTransport=createHttpWorldTransport({api,onMessage:handleServerMessage,isVisible:()=>!document.hidden,onConnection:(connected,error)=>{const wasConnected=state.connected;state.connected=connected;snowJamConnection(connected,error);liveContent?.setConnected(connected);if(!connected){controls?.clear();remotePresence?.clear();}else if(!wasConnected)controls?.clear();if(error)console.warn('World connection:',error.message);}});
    httpTransport.send({type:'presenceInterest',requestSeq:++presenceRequestSeq,baseWorldId:state.world.id,cameraPortalId:null,visiblePortalIds:[]});
    return;
  }
  const ws = new WebSocket(`${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}/ws?tab=${encodeURIComponent(presenceTabId)}`);
  state.socket = ws;
  ws.onopen = () => {
    if (ws !== state.socket) return;
    remotePresence?.clear();
    presenceKey = "";
    presenceSentAt = -Infinity;
    state.connected = true;
    snowJamConnection(true);
    ws.send(JSON.stringify({ type: "join" }));
  };
  ws.onmessage = (e) => {
    if (ws !== state.socket) return;
    let d;
    try {
      d = JSON.parse(e.data);
    } catch {
      return;
    }
    handleServerMessage(d);
  };
  ws.onclose = (e) => {
    if (ws !== state.socket) return;
    state.connected = false;
    snowJamConnection(false);
    remotePresence?.clear();
    pendingPresence = null;
    controls?.clear();
    if (state.player) { state.player.velocityX = 0; state.player.velocityZ = 0; }
    if (e.code === 4003) {
      state.accountRefreshRequired=true;snowJamObserve({type:"accountChanged",code:"ACCOUNT_CHANGED"});liveContent?.setConnected(false);closePanel();
      $("#save-status").textContent="Your sign-in changed · reload to continue";
      addConversation('Your sign-in changed. Reload to continue. Copy any unsent prompt before reloading.',{error:true});
      return;
    }
    if (e.code === 4001) {
      $("#save-status").textContent = "This tab reconnected elsewhere \xB7 reload to return";
      return;
    }
    $("#save-status").textContent = "Connection lost \xB7 reconnecting";
    setTimeout(connect, 2500);
  };
}
function send(d) {
  if ((snowJamOwnsFrame() || snowJamResetting) && ["input","interact","selectPortal","presenceInterest","avatarGesture"].includes(d?.type)) return Promise.resolve(false);
  if(httpTransport)return httpTransport.send(d);
  if(state.socket?.readyState===1){state.socket.send(JSON.stringify(d));return Promise.resolve(true);}
  return Promise.resolve(false);
}
let waveSequence=0,lastWaveAt=-Infinity;
function wave(){
  if (snowJamOwnsFrame()) return;
  const player=state.player;
  if(!player||state.time-lastWaveAt<2.2||player.grounded!==true||player.flying===true||Math.hypot(player.velocityX??0,player.velocityZ??0)>=.35)return;
  lastWaveAt=state.time;state.waveUntil=state.time+2;
  if(!LOCAL&&state.connected&&state.capabilities?.avatarGestures===true&&state.capabilities?.transport!=='http'){
    void send({type:'avatarGesture',gesture:'wave',seq:++waveSequence}).catch(error=>toast(error.message));
  }
}
async function resolveWorld(id) {
  if (id === "snowjam") throw Error("Snow Jam is an activity, not an ordinary portal destination.");
  if (LOCAL) {const world=state.localWorlds[id];if(world)await prepareSpawnSafety(world);return world;}
  if (worldCache.has(id)) {const world=worldCache.get(id);await prepareSpawnSafety(world);return world;}
  const data = await api(`/api/worlds/${encodeURIComponent(id)}`);
  const world = snowJamOrdinaryWorld(data.world ?? data);
  worldCache.set(id, world);
  await prepareSpawnSafety(world);
  return world;
}
async function setupScene() {
  renderer = new T.WebGLRenderer({ canvas: $("#world"), antialias: true, powerPreference: "high-performance" });
  renderer.setPixelRatio(Math.min(devicePixelRatio, 1.6));
  renderer.setSize(innerWidth, innerHeight);
  renderer.outputColorSpace = T.SRGBColorSpace;
  renderer.toneMapping = T.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.02;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = T.PCFSoftShadowMap;
  camera = new T.PerspectiveCamera(CAMERA_FRAMING.fov, innerWidth / innerHeight, 0.08, 700);
  xrPresentation=installXRPresentation({THREE:T,renderer,getStatusNotice:()=>snowJamMount?.portalFailureNotice?.()??'',getExperienceMode:()=>ssxPresentation.active()?'ssx':'valoria',withFirstPersonBody:({scene,camera,eyePosition,viewQuaternion,controllerPoses,unitsPerMeter},draw)=>{const local=localFirstPersonAvatar({scene,camera,eyePosition,avatarRoot:avatar?.root,avatarBody:avatar?.body});if(!local)return draw();const locomotion=firstPersonBodyLocomotion(),yaw=firstPersonBodyHeading({player:locomotion.player,cameraQuaternion:camera.quaternion,viewQuaternion,controlYaw:camYaw});return firstPersonHeading.withFrame({avatarRoot:local.root,avatarBody:local.body,yaw,anchorPosition:camera.position,enabled:!locomotion.riding&&camera.userData.valoriaFullRiderPose!==true},()=>firstPersonBody.withFrame({avatarRoot:local.root,avatarBody:local.body,preset:avatar.preset,controllerPoses,unitsPerMeter,locomotion},draw));},onNotice:toast,getViewMode:()=>viewPreference.get(),canEnter:()=>!!state.player&&!state.panel&&!accountAccessPanel?.isOpen&&!state.accountRefreshRequired,onToggleView:toggleCameraView,onReturnValoria:()=>returnToValoria(),canReturnValoria:()=>snowJamOwnsFrame()||state.world?.id!=='valoria',onInteract:()=>{if(placement){void confirmPortalPlacement();return;}if(snowJamOwnsFrame())snowJamMount?.xrInteract?.();else {interact();if(state.panel)void xrPresentation?.exit();}},onTurn:angle=>{if(!snowJamMount?.xrRiding?.())camYaw+=angle;},onClear:()=>{controls?.releasePointer();controls?.clear();}});
  renderer.localClippingEnabled = true;
  portals = createPortalRenderer({ renderer, resolveWorld, shouldPreloadDestination:world=>!isTrustedMirage(world), createWorldScene: (world) => createWorldScene(world, { time: state.time }), onError: (error, id) => console.warn(`Portal ${id}:`, error.message) });
  straddling = createPortalStraddling({
    renderer,
    deferPreparation:true,
    warmupObject:request=>portals.warmupObject(request),
    getCamera: () => camera,
    getWorldView: id => portals.getWorldView(id),
    ensureWorldView: world => portals.registerWorld(world),
    invalidateShadows: id => portals.invalidateShadows(id),
    onUnsupported: (id, reason) => console.warn(`Portal continuation ${id}: ${reason}`),
  });
  remotePresence = createRemotePresence({
    selfId: () => state.player?.id,
    // Retained remotes own one rig each; selected/activity avatars keep their own policy.
    createAvatar: (config, resident) => addNpcBadge(createAvatar(config, undefined, {modelCacheSize:1}), resident),
    identity: () => state.player?.accountId ?? state.player?.id,
    parkContinuation: id => straddling.parkRemote(id),
    isContinuationRetained: id => straddling.isRemoteParked(id),
    getWorldView: id => portals.getWorldView(id),
    getWorld: id => portals.getWorld(id),
    ensureWorld: ensurePresenceWorld,
    removeContinuation: id => straddling.remove(id),
    onError: error => console.warn("Remote presence:", error.message ?? error),
  });
  addEventListener("resize", () => {
    camera.aspect = innerWidth / innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(innerWidth, innerHeight);
  });
}
async function ensurePresenceWorld(id, revision = 0) {
  if (id === "snowjam") throw Error("Course presence cannot create an ordinary city world view.");
  const known = portals.getWorld(id);
  if (known && known.revision >= revision) return portals.getWorldView(id) ?? portals.registerWorld(known);
  const data = await api(`/api/worlds/${encodeURIComponent(id)}`), world = snowJamOrdinaryWorld(data.world ?? data);
  const current = portals.getWorld(id);
  if (current && current.revision > world.revision) return portals.getWorldView(id) ?? portals.registerWorld(current);
  worldCache.set(id, world);
  if (id === state.world.id) enterWorld(world, false);
  else portals.registerWorld(world);
  return portals.getWorldView(id);
}
function updatePresenceInterest(route) {
  if (LOCAL || !state.connected) return;
  const visiblePortalIds = portals.getRenderedPasses().filter(pass => pass.worldId === route.world.id).map(pass => pass.portalId).sort();
  const request = {baseWorldId: state.world.id, cameraPortalId: route.crossing?.source.id ?? null, visiblePortalIds};
  const key = JSON.stringify(request), now = performance.now();
  if (key === presenceKey || now - presenceSentAt < 220) return;
  send({type: "presenceInterest", requestSeq: ++presenceRequestSeq, ...request});
  presenceKey = key;
  presenceSentAt = now;
}
async function refreshNeighborWorlds() {
  if (LOCAL || refreshPending || !state.connected) return;
  refreshPending = true;
  const ids = [...new Set(selectedPortals(state.world, state.player.activePortalId).map((p) => p.targetWorldId))];
  try {
    await Promise.all(ids.map(async (id) => {
      if (id === state.world.id) return;
      try {
        const data = await api(`/api/worlds/${encodeURIComponent(id)}`), world = snowJamOrdinaryWorld(data.world ?? data);
        const existing = portals.getWorld(id);
        if (existing && existing.revision >= world.revision) return;
        await prepareSpawnSafety(world);
        worldCache.set(id, world);
        if (id === state.world.id) enterWorld(world, false);
        else portals.registerWorld(world);
      } catch (error) {
        console.warn("Neighbor refresh:", error.message);
      }
    }));
  } finally {
    refreshPending = false;
  }
}
function bindWorldView(view) {
  activeView = view;
  scene = view.scene;
  worldRoot = view.root;
  atmosphere = view.atmosphere;
  city = view.city;
  entities = view.entities;
  if (avatar) scene.add(avatar.root);
}
function enterWorld(world, transition = false) {
  if (!world) return;
  world = snowJamOrdinaryWorld(world);
  const changed = state.world?.id !== world.id;
  state.world = world;
  refreshValoriaReturnButton();
  publicActivity.reset(world.id);renderPublicActivity();
  state.player.worldId = world.id;
  worldCache.set(world.id, world);
  if (!portals) return;
  state.players.clear();
  const view = portals.registerWorld(world);
  portals.setPinnedWorlds([...new Set([world.id, ...(remotePresence?.getWorldIds() ?? [])])].slice(0, 6));
  bindWorldView(view);
  avatar?.root.position.copy(state.player.position);
  void prepareSpawnSafety(world);
  if (changed && transition) closePanel();
  if (LOCAL) persist();
}
function crossWorld({ player, world, sourcePortalId, targetPortalId, headingDelta }, predicted=false) {
  if (snowJamObserve({type:"crossed",player,world,sourcePortalId,targetPortalId,headingDelta})) return;
  world = snowJamOrdinaryWorld(world);
  presenceKey = "";
  traversalQuietUntil = performance.now()+500;
  diagnostics.event("body-crossing");
  if (!world || !player) return;
  if(!LOCAL&&!predicted&&player.id===state.player.id&&(player.crossingSeq??0)<=(state.player.crossingSeq??0))return;
  const sourceWorld=state.world;
  // Commit the same animated visual pose that was presented through the door.
  // Physical yaw can lead its native easing; snapping to it changes the pose.
  avatar.root.updateWorldMatrix(true,false);
  const avatarQuaternion = new T.Quaternion().setFromAxisAngle(new T.Vector3(0,1,0),headingDelta??0).multiply(avatar.root.getWorldQuaternion(new T.Quaternion())).normalize().toArray();
  const handoffPlayer = predicted ? player : reconcilePortalHandoff({current:state.player,authority:player,sourceWorld:state.world,targetWorld:world,worlds:portals.getWorlds(),pending:pendingCameraTraversal.status(),headingDelta});
  if(!predicted)movementPrediction.reset();
  socketMovementReconciliation.crossed(player);
  state.player = { ...state.player, ...handoffPlayer };
  pendingCameraTraversal.accept({player:state.player,sourceWorld,targetWorld:world});
  camYaw += headingDelta ?? 0;
  preferredPortal = targetPortalId;
  state.player.activePortalId = targetPortalId;
  enterWorld(world, false);
  placePortalAvatar(state.player, avatarQuaternion);
  // Ordinary portal body crossing preserves full spring-arm history.
  inputTimer = 0.1;
  state.near = null;
  $("#interaction").hidden = true;
  if (world.id === "valoria" && pendingAtelierPortal) {
    const selected = world.portals.find((p) => p.id === pendingAtelierPortal);
    if (selected) {
      selectPortal(selected);
      pendingAtelierPortal = null;
      toast("Your world is selected at the highlighted portal.");
    }
  }
}
function selectPortal(portal) {
  if (!portal || snowJamOwnsFrame() || portal.targetWorldId === "snowjam") return;
  preferredPortal = portal.id;
  state.player.activePortalId = portal.id;
  if (!LOCAL) void send({ type: "selectPortal", portalId: portal.id }).catch(error=>toast(error.message));
  const selectedWorld=state.world;
  void portals.preload(selectedWorld).then(()=>{
    if(state.world.id!==selectedWorld.id)return;
    if(snowJamMount?.ownsLocalContinuation?.())return;
    return straddling.prepare([{id:`player:${state.player.id}`,root:avatar.root,world:state.world,activePortalId:state.player.activePortalId,radius:1.2}],portals.getWorlds());
  }).catch(error=>console.warn("Doorway preparation:",error.message));
}
function blockedPortalWorldIds() {
  const blocked = blockedModelPortalWorldIds(state.world,portals.getWorlds(),id=>portals.isReady(id),state.player?.activePortalId);
  return snowJamEnabled ? [...new Set([...blocked,"snowjam"])] : blocked;
}
let flightToggleSeq=0;
function input(touch = {}, isolated = null) {
  const inputPlayer = isolated?.player ?? state.player, inputWorld = isolated?.world ?? state.world;
  keys.clear();
  for (const key of controls?.keys ?? []) keys.add(key);
  let x = (keys.has("d") || keys.has("arrowright") ? 1 : 0) - (keys.has("a") || keys.has("arrowleft") ? 1 : 0), z = (keys.has("s") || keys.has("arrowdown") ? 1 : 0) - (keys.has("w") || keys.has("arrowup") ? 1 : 0);
  x += touch.moveX || 0; z += touch.moveZ || 0;
  const {moveX,moveZ,yaw,lookYaw}=headRelativeMovement({x,z,cameraYaw:camYaw,headYaw:xrPresentation?.headingYaw(),fallbackYaw:inputPlayer.yaw});
  const flightLook=orbitLookAngles(orbitCameraPose(inputPlayer.position,lookYaw,camPitch,camDistance,camera.aspect));
  // Never reuse a sequence below a restored or reconciled flight edge.
  // Older server idle packets could persist lastInputSeq=0 with a larger
  // lastFlightToggleSeq; advancing above both heals those accounts on input.
  const sequenceFloor=Math.max(inputPlayer.lastInputSeq??0,inputPlayer.lastFlightToggleSeq??0,isolated ? isolated.flightToggleSeq : flightToggleSeq);
  if(isolated)isolated.seq=Math.max(isolated.seq,sequenceFloor);else seq=Math.max(seq,sequenceFloor);
  const nextSeq=isolated ? ++isolated.seq : ++seq, toggle=controls?.consumeFlightToggle()||touch.flightToggle;
  let inputFlightToggleSeq=Math.max(isolated ? isolated.flightToggleSeq : flightToggleSeq,inputPlayer.lastFlightToggleSeq??0);
  if(toggle&&flightAllowed(inputWorld))inputFlightToggleSeq=nextSeq;
  if(isolated)isolated.flightToggleSeq=inputFlightToggleSeq;else flightToggleSeq=inputFlightToggleSeq;
  return { flightToggleSeq:inputFlightToggleSeq,...flightLook,moveY:inputPlayer.flying?((keys.has(" ")?1:0)-(keys.has("c")?1:0)+(touch.moveY||0)):0, blockedPortalWorldIds:isolated ? [] : blockedPortalWorldIds(), type: "input", worldId: inputPlayer.worldId, seq: nextSeq, moveX, moveZ, yaw, jump: keys.has(" ") || !!touch.jump, sprint: keys.has("shift") || controllerSample.sprint===true || (inputPlayer.flying&&touch.sprint===true) };
}
/** Resolve collisions across both physical segments, then ease one full spring
 * arm. A portal changes coordinate charts; it never resets arm history.
 * Re-routing the resolved eye keeps it in the source world while a shortened
 * arm has not yet reached the opening. segmentClearance returns the physical
 * unsmoothed collision ceiling for its world, in the caller's common units. */
function resolvePortalCameraArm({world,target,desired,previousDistance=Infinity,dt,routeFor,segmentClearance}) {
  const length=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y,a.z-b.z);
  const requested=routeFor(desired);
  let allowed;
  if(requested.crossing) {
    const intersection=requested.crossing.intersection,sourceLength=length(target,intersection);
    const sourceArm=segmentClearance({world,target,desired:intersection,dt});
    if(sourceArm.distance+.08<sourceLength)allowed=sourceArm.distance;
    else allowed=sourceLength+segmentClearance({world:requested.world,target:requested.armStart,desired:requested.desired,dt}).distance;
  } else allowed=segmentClearance({world,target,desired:requested.desired,dt}).distance;
  const distance=allowed<previousDistance?allowed:Math.min(allowed,previousDistance+(allowed-previousDistance)*(1-Math.exp(-Math.max(0,dt)*11)));
  const full=length(target,desired),fraction=full>.001?distance/full:0;
  const sourceDesired={x:target.x+(desired.x-target.x)*fraction,y:target.y+(desired.y-target.y)*fraction,z:target.z+(desired.z-target.z)*fraction};
  const route=routeFor(sourceDesired);
  return {route,sourceDesired,arm:{...route.desired,distance},allowedDistance:allowed};
}

let xrTrackingInterrupted=false;
function tick(_timestamp,xrFrame) {
  const recording=diagnostics.active,timing=recording?{}:null;let mark=recording?performance.now():0;
  const span=name=>{if(recording){const now=performance.now();timing[name]=now-mark;mark=now;}};
  const frameTime = clock.getDelta();
  // A reference reset may arrive without an animation frame. Discard the gap
  // before sampling controls, and do not advance worlds with an invalid pose.
  const interrupted=xrTrackingInterrupted||xrPresentation?.isTrackingAvailable()===false;
  const dt=interrupted?0:Math.min(frameTime,0.055);
  xrPresentation?.update(xrFrame,dt);
  xrTrackingInterrupted=xrPresentation?.isTrackingAvailable()===false;
  if(xrTrackingInterrupted)return;
  updateController(dt);
  state.time += dt;
  frame++;
  if (snowJamAdvanceFrame(dt,state.time)) {
    span("snowJamOwnedMilliseconds");
    if(recording)diagnostics.record({frameMilliseconds:frameTime*1000,...timing,...snowJamFrameDiagnostics()});
    return;
  }
  if (!state.player || !activeView) return;
  const touch = combinedTouch();
  camYaw -= (touch.lookX || 0) * dt * 2.15;
  camPitch = T.MathUtils.clamp(camPitch + (touch.lookY || 0) * dt * 1.6, CAMERA_FRAMING.minPitch, CAMERA_FRAMING.maxPitch);
  mobileControls?.updateContext();
  const flightHint=$('#flight-hint'),flightHelp=state.player.flying?'Up · C down · Shift boost':flightAllowed(state.world)?'Jump · double-tap to fly':'Jump';
  if(flightHint&&flightHint.textContent!==flightHelp){flightHint.textContent=flightHelp;flightHint.title=state.player.flying?'Double-tap Space within 450 ms to stop flying':'';}
  const inp = input(touch);
  socketMovementReconciliation.record(inp,state.player);
  const previous = { ...state.player, position: { ...state.player.position } };
  if(!LOCAL&&state.capabilities?.transport!=="http") {
    const corrected=socketMovementReconciliation.advance(state.player,dt,state.world,{presentation:pendingCameraTraversal.motion({player:state.player,world:state.world,worlds:portals.getWorlds()}),worlds:portals.getWorlds()});
    if(corrected!==state.player)snowJamMount?.resetEntryObservation?.(corrected.position);
    state.player=corrected;
  }
  if (!LOCAL && state.capabilities?.transport === 'http') {
    // Every predicted frame is sent in order, including idle/typing frames. HTTP
    // batches them without replacing a preceding move or jump with its release.
    const prediction = movementPrediction.record(state.player, state.connected ? inp : {...inp, moveX:0, moveZ:0, moveY:0, flightToggleSeq:state.player.lastFlightToggleSeq??0, jump:false, sprint:false}, state.connected ? dt : 0, state.world, portals.getWorlds());
    state.player = prediction.player;
    if(prediction.crossing)crossWorld({player:prediction.player,...prediction.crossing},true);
    send(prediction.sample);
  } else if (LOCAL || state.connected) state.player = stepPortalPrediction({player:state.player,input:inp,dt,world:state.world,worlds:portals.getWorlds(),pending:pendingCameraTraversal.motion({player:state.player,world:state.world,worlds:portals.getWorlds()}),resolveMovement:snowJamConstrainCityMovement}) ?? snowJamConstrainCityMovement(state.player,stepMovement(state.player, inp, dt, state.world),dt,state.world);
  if (!LOCAL && state.capabilities?.transport !== 'http' && inp.blockedPortalWorldIds.length) {
    const waiting=stepPortalCrossing(previous,state.player,state.world,portals.getWorlds(),dt,{preparedOnly:true,blockedPortalWorldIds:inp.blockedPortalWorldIds});
    if(waiting.blockedPortalId)state.player=waiting.player;
  }
  if (LOCAL) {
    const result = stepPortalCrossing(previous, state.player, state.world, state.localWorlds, dt, {preparedOnly:true,blockedPortalWorldIds:inp.blockedPortalWorldIds});
    state.player = result.player;
    if(result.blockedPortalId){const target=state.localWorlds[state.world.portals.find(p=>p.id===result.blockedPortalId)?.targetWorldId];if(target&&!isSpawnSafetyPrepared(target))void prepareSpawnSafety(target);}
    if (result.crossing) crossWorld({ player: result.player, ...result.crossing });
  }
  pendingCameraTraversal.observe({previous,player:state.player,world:state.world,worlds:portals.getWorlds(),dt,enabled:!LOCAL&&state.connected&&state.capabilities?.transport!=="http",blockedPortalWorldIds:inp.blockedPortalWorldIds});
  span("movementMilliseconds");
  inputTimer += dt;
  if (!LOCAL && state.capabilities?.transport !== "http" && (inputTimer > 0.05 || inputNeedsImmediateSend(inp, lastSentInput) || inp.flightToggleSeq>(previous.lastFlightToggleSeq??0))) {
    send(inp);
    lastSentInput = inp;
    inputTimer = 0;
  }
  const p = state.player.position;
  avatar.root.position.set(p.x, p.y, p.z);
  avatar.root.rotation.y = T.MathUtils.lerp(avatar.root.rotation.y, unwrap(avatar.root.rotation.y, state.player.yaw), Math.min(1, dt * 13));
  const speed = Math.hypot(state.player.velocityX ?? 0, state.player.velocityZ ?? 0);
  avatar.update(dt, state.time, speed, !state.player.grounded, state.time < state.waveUntil, {flying:state.player.flying===true,flightSpeed:Math.hypot(state.player.velocityX??0,state.player.velocityY??0,state.player.velocityZ??0)});
  span("avatarMilliseconds");
  updatePortalPlacement();
  void pollCreationJobs();
  void liveContent?.poll();
  const snowJamPreviousCameraArmLength=cameraArmLength;
  hostViewBlend=hostViewTransition.sample({thirdPerson:viewPreference.get()==='third-person',dt});
  const firstView=viewCameraPose(p,'first-person');
  const thirdView=(!xrPresentation?.active()?snowJamReturnedOrbit(p):null)??viewCameraPose(p,'third-person');
  if(hostViewBlend===0&&viewPreference.get()==='first-person'){snowJamReturnedCamera?.clear();snowJamReturnedCamera=null;}
  const orbit=blendViewPose(firstView,thirdView,hostViewBlend);
  cameraTarget.copy(orbit.target);
  cameraDesired.copy(orbit.desired);
  const cameraTraversal=state.player.portalTraversal;
  const cameraFrame=pendingCameraTraversal.frame({player:state.player,world:state.world,worlds:portals.getWorlds(),target:cameraTarget,desired:cameraDesired,activePortalId:state.player.activePortalId,traversal:cameraTraversal});
  const resolvedArm = resolvePortalCameraArm({world:cameraFrame.world,target:cameraFrame.target,desired:cameraFrame.desired,previousDistance:cameraArmLength,dt,routeFor:eye=>routeCameraThroughPortal(cameraFrame.world,portals.getWorlds(),cameraFrame.target,eye,cameraFrame.activePortalId,id=>isModelDestinationReady(id,portals.getWorlds(),key=>portals.isReady(key)),cameraFrame.traversal),segmentClearance:({world,target,desired,dt})=>clampCameraArm(target,desired,worldColliders(world),Infinity,dt)});
  const route=resolvedArm.route,arm=resolvedArm.arm;
  route.cameraHeadingDelta=cameraRouteHeading(cameraFrame,route);
  route.pendingBodyTraversal=cameraFrame.pending;
  const viewChanged = renderWorldId !== route.world.id;
  if (viewChanged || renderView !== portals.getWorldView(route.world.id) || renderView?.world.revision !== route.world.revision) {
    diagnostics.event("camera-world-change");
    renderView = portals.setWorld(route.world, void 0, { activePortalId: route.portalId });
    renderWorldId = route.world.id;
  }
  cameraArmLength = arm.distance;
  publishNativeCamera(camera,()=>{
    camera.userData.valoriaFullRiderPose=false;
    camera.position.set(arm.x, arm.y, arm.z);
    const heading=camYaw+(route.cameraHeadingDelta||0);
    if(xrPresentation?.active())camera.rotation.set(0,heading,0,'YXZ');
    else {
      camera.lookAt(route.target.x,route.target.y,route.target.z);
      const thirdOrientation=thirdView.quaternion?.clone()??camera.quaternion.clone();
      if(thirdView.quaternion&&route.cameraHeadingDelta)thirdOrientation.premultiply(new T.Quaternion().setFromAxisAngle(new T.Vector3(0,1,0),route.cameraHeadingDelta));
      camera.rotation.set(-camPitch,heading,0,'YXZ');
      camera.quaternion.slerp(thirdOrientation,hostViewBlend);
      if(hostViewBlend===1)snowJamApplyReturnedCamera(route);
    }
    camera.userData.valoriaFirstPersonBody=arm.distance<.5;
    camera.userData.valoriaShowCompleteRider=arm.distance>=.5;
  });
  // A portal segment can be tiny while the real eye is far from the player.
  // Keep the character visible; cramped geometry may require a close view,
  // rather than hiding the player or pushing the camera through a wall.
  avatar.body.visible = true;
  xrPresentation?.prepare(camera);
  span("cameraMilliseconds");
  activeView.update(dt, state.time);
  renderView.update(dt, state.time);
  remotePresence.update(dt, state.time, state.player.worldId);
  worldMinimap.update({world:snowJamMount?.navigationWorld(state.world)??state.world,player:state.player,participants:remotePresence.mapParticipants(state.world.id),region:state.region,time:state.time});
  if (!LOCAL && state.capabilities?.transport!=="http" && state.time - lastWorldRefresh > 4) {
    lastWorldRefresh = state.time;
    void refreshNeighborWorlds();
  }
  if (frame % 5 === 0) findInteraction();
  $(".controls").classList.toggle("quiet", activeInputDevice==='keyboard'&&(state.time > 8 || !!state.panel || controls?.isLocked()));
  if (LOCAL && state.time - lastSave > 2) {
    lastSave = state.time;
    persist();
  }
  span("sceneUpdateMilliseconds");
  // One animated source pose feeds both clipped halves. This is presentation
  // only: avatar movement and authored-object authority stay in their own world.
  const snowJamOwnsLocalContinuation=snowJamMount?.ownsLocalContinuation?.();
  if(cameraFrame.pending)snowJamMount?.renderCityPortals(camera,{dt,time:state.time});
  withPendingBodyPresentation({THREE:T,root:avatar.root,frame:cameraFrame,scene:portals.getWorldView(cameraFrame.world.id)?.scene},()=>{
  const continuationObjects = snowJamOwnsLocalContinuation ? [] : [{id: `player:${state.player.id}`, root: avatar.root, world: cameraFrame.world, activePortalId: cameraFrame.activePortalId, portalTraversal: cameraFrame.pending?cameraFrame.traversal:state.player.portalTraversal, radius: 1.2}];
  const observedWorldIds = new Set(remotePresence.getWorldIds());
  for (const descriptor of remotePresence.descriptors()) continuationObjects.push({...descriptor, allowSceneCreation: false, allowedTargetWorldIds: observedWorldIds});
  const propWorldIds = new Set([state.world.id, cameraFrame.world.id, route.world.id, ...selectedPortals(route.world, route.portalId).slice(0, 3).map(portal => portal.targetWorldId)]);
  for (const id of propWorldIds) {
    const world = portals.getWorld(id), view = portals.getWorldView(id);
    if (!view) continue;
    view.update(dt, state.time);
    for (const [entityId, object] of view.entities?.objects ?? []) continuationObjects.push({id: `entity:${id}:${entityId}`, root: object.group, world, allowSceneCreation: false, allowedTargetWorldIds: propWorldIds});
  }
  const continuation = straddling.sync(continuationObjects, portals.getWorlds());
  portals.setPinnedWorlds([...new Set([state.world.id, cameraFrame.world.id, route.world.id, ...continuation.pinnedWorldIds, ...remotePresence.getWorldIds()])].slice(0, 6));
  span("straddlingMilliseconds");
  const snowJamReturnedFrame = snowJamRenderReturnedFrame(dt,route,snowJamPreviousCameraArmLength);
  if (!snowJamReturnedFrame) {
    if(!cameraFrame.pending)snowJamMount?.renderCityPortals(camera,{dt,time:state.time});
    portals.render(camera, { dt, frameTime, time: state.time, activePortalId: route.portalId, cameraCrossing: route.crossing, portalTraversal: cameraFrame.traversal });
  }
  span("portalSubmitMilliseconds");
  updatePresenceInterest(route);
  if (!snowJamReturnedFrame) renderer.render(renderView.scene, camera);
  });
  arrivalTransition?.rendered({assetsReady: portals.isReady(state.world.id)});
  snowJamMount?.observeCityMovement?.(previous,state.player,{dt,time:state.time,input:inp});
  span("mainSubmitMilliseconds");
  if(recording)diagnostics.record({frameMilliseconds:frameTime*1000,...timing,...snowJamFrameDiagnostics()});
  if (previewRenderer && ['avatar','onboarding','profile','account'].includes(state.panel)) {
    avatarPreview.update(dt, state.time, 0);
    avatarPreview.root.rotation.y = Math.sin(state.time * 0.3) * 0.18;
    previewRenderer.render(previewScene, previewCamera);
  }
}
function unwrap(a, b) {
  return a + Math.atan2(Math.sin(b - a), Math.cos(b - a));
}
function findInteraction() {
  const p = state.player.position, candidates = [];
  for (const npc of remotePresence?.residents(state.world.id) ?? []) candidates.push({kind:"npc",item:npc,distance:Math.hypot(p.x-npc.position.x,p.z-npc.position.z),range:3.6});
  candidates.push(...resortInteractionCandidates(state.world,p));
  for (const e of entities?.interactables ?? []) candidates.push({ kind: "instrument", item: e, distance: Math.hypot(p.x - e.position.x, p.z - e.position.z), range: 3.6 });
  for (const b of state.world.behaviors ?? []) {
    const e = state.world.entities.find((e2) => e2.id === b.entityId);
    if (e && !candidates.some((c) => c.item.id === e.id)) candidates.push({ kind: "behavior", item: e, distance: Math.hypot(p.x - e.position.x, p.z - e.position.z), range: 4 });
  }
  candidates.sort((a, b) => a.distance - b.distance);
  state.near = candidates.find((c) => c.distance < c.range);
  $("#interaction").hidden = !state.near;
  if (state.near) $("#interaction-text").textContent = `${state.near.kind === "npc" ? "Talk to" : state.near.kind === "instrument" ? "Play" : "Use"} ${state.near.item.label || state.near.item.name || "object"}`;
  $("#interaction kbd").textContent = window.matchMedia("(pointer: coarse)").matches ? (Math.hypot(state.player.velocityX || 0, state.player.velocityZ || 0) > .35 || state.player.grounded === false ? "B" : "A") : "E";
}
function interact() {
  if (snowJamOwnsFrame() || !state.near) return;
  const { item } = state.near;
  if(state.near.kind==='resort'){openPanel(item.kind==='poker'?'resort-poker':'resort-slots',{variant:item.variant});return;}
  if(state.near.kind==="npc"){void api("/api/npc-greeting",{npcId:item.id}).then(reply=>remotePresence.greet(reply)).catch(error=>toast(error.message));return;}
  if (LOCAL) {
    const note = item.capabilities?.find((c) => c.type === "resonance")?.note;
    if (note) {
      playNote(note);
      entities.pulse(item.id);
    } else toast("This interaction could not connect. Try again when the world is connected.");
  } else void send({ type: "interact", entityId: item.id }).catch(error=>toast(error.message));
}
function playNote(note = 60) {
  if (!audioContext) audioContext = new (window.AudioContext || window.webkitAudioContext)();
  audioContext.resume();
  const t = audioContext.currentTime, f = 440 * 2 ** ((note - 69) / 12);
  for (let i = 1; i < 4; i++) {
    const o = audioContext.createOscillator(), g = audioContext.createGain();
    o.type = "sine";
    o.frequency.value = f * i;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.13 / i, t + 0.025);
    g.gain.exponentialRampToValueAtTime(1e-3, t + 2.4 / i);
    o.connect(g);
    g.connect(audioContext.destination);
    o.start();
    o.stop(t + 3);
  }
}
// Kept as a neutral boundary hook. Ambient hum has been removed.
function setAmbient() {}
let ownerCreationUi=null;
let creationArmed=false,creationEpoch=0;
let composer, creationKind = 'auto', creationTarget=null, latestJobs = [], jobsPollAt = 0, jobsBusy = false, jobsLoaded = false, jobsError = '';
let historySignature='';
const creationRequests = new Map();
function focusWorld() { document.activeElement?.blur?.(); $("#world").focus({preventScroll:true}); }
function renderPublicActivity(){
  const list=$("#activity-entries");if(!list)return;
  $("#world-activity").hidden=LOCAL||state.capabilities?.publicActivity!==true;
  const nearBottom=list.scrollHeight-list.scrollTop-list.clientHeight<40;
  list.replaceChildren(...publicActivity.entries().map(event=>{const row=document.createElement('p'),time=document.createElement('time');time.dateTime=new Date(event.time).toISOString();time.textContent=new Date(event.time).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});row.append(time,document.createTextNode(' '+activityText(event.kind==='action'?{...event,text:String(event.text??'').replace(/\bfree-token\b/g,'free-play')}:event)));return row;}));
  if(!list.childElementCount){const empty=document.createElement('p');empty.textContent=LOCAL?'Public activity is available in connected worlds.':'No recent public activity in this world.';list.append(empty);}
  if(nearBottom)list.scrollTop=list.scrollHeight;
}
function addConversation(text, {name, error=false,scope=name?'chat':'create'}={}) {
  const list=$(scope==='chat'?'#conversation':'#creation-conversation');if(!list)return;
  const row=document.createElement('p');if(error)row.className='error';
  if(name){const who=document.createElement('strong');who.textContent=name+': ';row.append(who);}
  row.append(document.createTextNode(text));list.append(row);while(list.childElementCount>6)list.firstElementChild.remove();
  list.hidden=false;list.scrollTop=list.scrollHeight;const empty=$('.chat-empty');if(scope==='chat'&&empty)empty.hidden=true;if(error){if($('#composer-mode').value===scope)setComposerDisclosure(true);else toast(text);}
}
function beginCreation(kind='auto',target=null) {
  if(ssxPresentation.active())return;
  if(snowJamOwnsFrame()){toast('Use Back to city before creating or editing.');return false;}
  if(kind==='world'&&(!target||target.ownerId!==(state.player?.accountId??state.player?.id))){kind='new-world';target=null;}
  creationArmed=true;creationEpoch++;creationKind=kind==='auto'?'new-world':kind;creationTarget=target;
  closePanel();setComposerMode('create',{focus:true});return true;
}
async function submitComposer({text,mode}) {
  if (snowJamOwnsFrame()) { if(mode==="chat")return snowJamMount.submitChat(text); throw Error("Use Back to city before sending creation requests."); }
  if(mode==='chat') {
    if(LOCAL||!state.connected)throw Error('Chat could not connect. Your message is still here.');
    if(text.length>280)throw Error('Keep chat messages under 280 characters.');
    await send({type:'chat',text});return true;
  }
  if(!creationArmed)throw Error('Choose what to make in Create. Your request is still here.');
  if(ownerCreationUi?.accepts()){
    const submittedEpoch=creationEpoch;
    // Calling submit immediately preserves the trusted composer user activation.
    const result=await ownerCreationUi.submit({prompt:text,target:creationTarget});
    addConversation(creationPersistenceText(result.text),{error:!result.accepted});
    if(!result.accepted)return false;
    if(result.job)latestJobs=[result.job,...latestJobs.filter(item=>item.id!==result.job.id)].slice(0,20);
    jobsPollAt=0;historySignature='';refreshCreationHistory();
    if(creationEpoch===submittedEpoch)composer?.refresh();
    return true;
  }
  if(LOCAL||!state.capabilities?.creationQueue)throw Error('Creation could not connect. Your request is still here.');
  const submittedEpoch=creationEpoch;
  const intent=creationTarget?(creationTarget.ownerId===(state.player.accountId??state.player.id)?'edit':'fork'):'create';
  const context={kind:creationKind,prompt:text,intent,...(creationTarget?{creationId:creationTarget.id,worldId:creationKind==='world'?creationTarget.id:undefined,baseRevision:creationTarget.revision}:{}),context:{sourceWorldId:state.world.id,position:{...state.player.position},yaw:camYaw+Math.PI}};
  const key=JSON.stringify(context);let requestId=creationRequests.get(key);if(!requestId){requestId=crypto.randomUUID();creationRequests.set(key,requestId);if(creationRequests.size>24)creationRequests.delete(creationRequests.keys().next().value);}
  const response=await api('/api/creation-jobs',{...context,requestId});
  const job=response.job??response;latestJobs=[job,...latestJobs.filter(item=>item.id!==job.id)].slice(0,20);
  addConversation(job.status==='complete'?'Your creation is ready.':job.status==='working'?'Working on your creation. Rough estimate: 5–10 min; follow progress in Requests.':job.status==='blocked'?(job.reason||'This creation needs another step.'):(persistenceFeedback(response)?.message??'Request saved. Check Create → Requests for progress.'));
  creationRequests.delete(key);jobsPollAt=0;historySignature='';refreshCreationHistory();if(creationEpoch===submittedEpoch){creationArmed=false;creationTarget=null;creationKind='auto';composer?.refresh();}return true;
}
async function pollCreationJobs(){
  if(LOCAL||!(state.capabilities?.creationQueue||ownerCreationUi?.available())||jobsBusy||document.hidden||state.time<jobsPollAt)return;
  jobsBusy=true;jobsPollAt=state.time+4;
  try{
    const {jobs=[]}=await api('/api/creation-jobs');let completed=false;jobsLoaded=true;jobsError='';
    for(const job of jobs){
      const previous=latestJobs.find(item=>item.id===job.id);
      if(!previous||previous.status===job.status)continue;
      if(job.status==='applied'){completed=true;addConversation('Your world change is applied.');}
      else if(job.status==='ready')addConversation(job.kind==='world'?'The builder returned a world result. It has not been applied yet.':'The builder returned a proposal for review.');
      else if(job.status==='claimed')addConversation('The builder is working on this request.');
      else if(job.status==='complete'||job.status==='completed'){completed=true;addConversation(job.result?.summary||job.message||'Your creation is ready.');}
      else if(job.status==='failed'||job.status==='blocked')addConversation(job.error||job.reason||'This creation needs another step.',{error:true});
      else if(job.status==='working'||job.status==='running')addConversation('Working on your creation. Rough estimate: 5–10 min; follow progress in Requests.');
    }
    latestJobs=jobs;
    if(completed){const catalog=await api('/api/worlds');state.worlds=snowJamOrdinaryWorlds(catalog.worlds)??state.worlds;if(state.panel==='worlds')directoryPanel('worlds');}
  }catch(error){jobsError=error.message;console.warn('Creation status:',error.message);}finally{jobsBusy=false;refreshCreationHistory();}
}
function refreshCreationHistory(){
  if(state.panel!=='requests')return;
  const container=$('#request-history');if(!container)return;
  const signature=JSON.stringify([latestJobs,jobsLoaded,jobsError,Math.floor(Date.now()/60000)]);if(signature===historySignature)return;historySignature=signature;
  renderCreationHistory({container,jobs:latestJobs,loading:!jobsLoaded&&!jobsError,error:jobsError,
    onOpenWorld:id=>beginPortalPlacement(id),
    onCancel:async job=>{const status=$('#request-action-status');if(status){status.textContent='';status.hidden=true;}try{const response=await api('/api/owner-creation/cancel',{jobId:job.id});const updated=response.job??response;latestJobs=latestJobs.map(item=>item.id===updated.id?updated:item);jobsPollAt=0;historySignature='';refreshCreationHistory();await pollCreationJobs();}catch(error){if(status?.isConnected){status.textContent=(error.persistence||error.publicationError?'': 'Could not cancel this request. ')+error.message;status.hidden=false;}else toast((error.persistence||error.publicationError?'': 'Could not cancel this request. ')+error.message);}},
    onRevise:job=>{const intent=job.intent??job.context?.intent;const world=[...state.worlds,...(state.creations??[])].find(item=>item.id===(job.world_id??job.worldId));if(beginCreation(job.kind??'auto',intent==='edit'||intent==='fork'?world:null)===false)return;composer?.setText(job.prompt);$('#composer-input')?.focus({preventScroll:true});},
  });
}
function offerLocalImport(){
  if(LOCAL||!state.capabilities?.localImport)return;
  let candidate;try{candidate=localWorldImportCandidate(localStorage.getItem('valoria-reality-v1'));if(!candidate||localStorage.getItem('valoria-imported-worlds')===candidate.signature)return;}catch{return;}
  const row=document.createElement('div');row.className='import-offer';const label=document.createElement('p');label.textContent=`Bring ${candidate.count===1?'your saved world':candidate.count+' saved worlds'} into your Valoria account? The original saves will stay on this device.`;row.append(label);
  const yes=document.createElement('button'),later=document.createElement('button');yes.type=later.type='button';yes.textContent='Import saved worlds';later.textContent='Not now';row.append(yes,later);$('#creation-conversation').append(row);$('#creation-conversation').hidden=false;
  const requestId=crypto.randomUUID();later.onclick=()=>{row.remove();if(!$('#creation-conversation').childElementCount)$('#creation-conversation').hidden=true;};yes.onclick=async()=>{yes.disabled=true;try{if(candidate.count>20||candidate.bytes>1000000)throw Error('This save is too large to import together. The originals are unchanged.');const result=await api('/api/import-local',{requestId,worlds:candidate.worlds});const catalog=await api('/api/worlds');state.worlds=snowJamOrdinaryWorlds(catalog.worlds)??state.worlds;try{localStorage.setItem('valoria-imported-worlds',candidate.signature);}catch{}row.remove();addConversation(result.removedConnections?'Your worlds are imported. Place new portals to connect them.':'Your saved worlds are imported.');}catch(error){addConversation(error.message,{error:true});yes.disabled=false;}};
}
function setupLiveContent(){
  if(LOCAL||state.capabilities?.transport!=='http')return;
  liveContent=createLiveContentSync({api,getKnownWorlds:()=>portals.getWorlds(),isVisible:()=>!document.hidden,connected:state.connected,catalogRevision:state.catalogRevision,
    onWorld:async(world,{isCurrent})=>{if(snowJamOwnsFrame()||snowJamSourceWorld(world))return;world=snowJamOrdinaryWorld(world);await prepareSpawnSafety(world);if(!isCurrent())return;const existing=portals.getWorld(world.id);if(existing&&existing.revision>=world.revision)return;await portals.updateWorld(world,{isCurrent});if(!isCurrent())return;handleServerMessage({type:'world',world});},
    onCatalog:async(worlds,{catalogRevision,isCurrent})=>{const response=await api('/api/creations');if(!isCurrent())return;state.worlds=snowJamOrdinaryWorlds(worlds);state.creations=response.creations??state.creations;state.catalogRevision=catalogRevision;if(state.panel==='worlds')directoryPanel('worlds');},
  });
}
let valoriaReturnBusy=false;
function refreshValoriaReturnButton(){
  const button=$('#return-valoria-button');if(!button)return;
  button.hidden=!ssxPresentation.active()&&!snowJamOwnsFrame()&&state.world?.id==='valoria';
  button.disabled=valoriaReturnBusy||state.accountRefreshRequired===true;
  button.textContent=valoriaReturnBusy?'Returning…':ssxPresentation.active()?'Exit SSX':'Return to Valoria';
  button.setAttribute('aria-label',button.textContent);button.title=button.textContent;
}
const returnToValoria=createValoriaReturnAction({
  getPlayer:()=>state.player,
  leaveActivity:async()=>{
    closePanel();composer?.setMenu(false);setComposerDisclosure(false);stopPortalPlacement();
    controls?.releasePointer();controls?.clear();mobileControls?.clear();keys.clear();
    return snowJamPrepareWorldAction();
  },
  request:async()=>{
    const requestId=crypto.randomUUID();
    if(!LOCAL)return api('/api/return-valoria',{requestId});
    const world=state.localWorlds.valoria;await prepareSpawnSafety(world);
    return {type:'returnedValoria',requestId,world,player:returnedValoriaPlayer(state.player,world)};
  },
  apply:result=>{handleServerMessage(result);ssxPresentation.returned();refreshValoriaReturnButton();if(LOCAL)persist();focusWorld();},
  onBusy:value=>{valoriaReturnBusy=value;refreshValoriaReturnButton();},
});
let activityDrawer;
function bindUI() {
  // Trusted host bootstrap keeps this default-off. These are UI policy guards,
  // never account authority; server routes reauthenticate every owner action.
  ownerCreationUi=createNativeOwnerUi({local:LOCAL,enabled:!LOCAL&&state.capabilities?.ownerCreationSetup===true&&state.capabilities?.ownerCreationBrowserPolicy===true,window,document,getState:()=>state,api,onMessage:(text,options)=>addConversation(creationPersistenceText(text),options),reviewRoot:document.body,onKindChange:kind=>{creationKind=kind;creationEpoch++;if(kind!=='world')creationTarget=null;refreshCreationTarget();composer?.refresh();},onAvailabilityChange:()=>{composer?.refresh();refreshCreatorConnection();refreshNavigation();},referrerPolicyReady:state.capabilities?.ownerCreationBrowserPolicy===true});
  ownerCreationUi.installKindSelector($('#creation-options'));
  activityDrawer=installActivityDrawer({root:$('#world-activity'),releasePointer:()=>controls?.releasePointer(),onOpen:()=>worldMinimap.collapse()});
  for(const section of ['worlds','profile','help'])$(`#${section}-button`).onclick=()=>{if(state.panel===section)closePanel({restoreFocus:true});else openPanel(section);};
  accountAccessPanel=createAccountModal({layer:$('#hud-modal'),underlay:$('#hud-base'),world:$('#world'),getOptions:()=>({local:LOCAL,account:state.account,accountRefreshRequired:state.accountRefreshRequired,accountUncertain:state.accountUncertain,returnStatus:accountReturnStatus,onUncertain:pauseForUncertainAccount,hasPrivateDraft:()=>composer?.hasDraft('create')===true}),onOpen:()=>{controls?.releasePointer();mobileControls?.clear();},onError:error=>toast('Could not open account. '+error.message)});
  $('#signin-button').onclick=()=>accountAccessPanel.open();
  $('#return-valoria-button').onclick=()=>{void returnToValoria().catch(error=>toast(error.message));};
  $("#explore-button").onclick=()=>{closePanel();focusWorld();controls?.requestCapture();};
  $("#panel-close").onclick=()=>closePanel({restoreFocus:true});
  refreshNavigation();
  const canvas=$("#world");canvas.tabIndex=0;
  window.addEventListener("keydown",()=>{activeInputDevice="keyboard";});
  window.addEventListener("mousemove",event=>{if(event.movementX||event.movementY)activeInputDevice="keyboard";});
  window.addEventListener("pointerdown",event=>{activeInputDevice=event.pointerType==="touch"?"touch":"keyboard";});
  window.addEventListener("blur",()=>{standardController.clear();controllerSample={};});
  document.addEventListener("visibilitychange",()=>{if(document.hidden){standardController.clear();controllerSample={};}});
  controls=installWorldControls({canvas,flightAllowed:()=>snowJamOwnsFrame()?flightAllowed(snowJamWalkingInputContext()?.world):flightAllowed(state.world),isFlying:()=>(snowJamOwnsFrame()?snowJamWalkingInputContext()?.player:state.player)?.flying===true,onClear:()=>{mobileControls?.clear(false);keys.clear();lastSentInput=null;snowJamMount?.clearInput();if(snowJamOwnsFrame()&&!snowJamResetting)snowJamResetMovement();if(!snowJamOwnsFrame()&&!snowJamResetting&&!LOCAL&&state.connected){const stop={blockedPortalWorldIds:blockedPortalWorldIds(),type:'input',worldId:state.player?.worldId,seq:++seq,moveX:0,moveZ:0,jump:false,sprint:false,yaw:state.player?.yaw??Math.PI};socketMovementReconciliation.record(stop,state.player);if(state.capabilities?.transport==='http'){const prediction=movementPrediction.record(state.player,stop,0,state.world,portals.getWorlds());state.player=prediction.player;send(prediction.sample);}else send(stop);}},onLook:(dx,dy)=>{if(snowJamOwnsFrame()){snowJamMount?.onLook?.(dx,dy);return;}camYaw-=dx*22e-4;camPitch=T.MathUtils.clamp(camPitch+dy*22e-4,CAMERA_FRAMING.minPitch,CAMERA_FRAMING.maxPitch);},onZoom:dy=>{if(snowJamOwnsFrame()){snowJamMount?.onZoom?.(dy);return;}camDistance=T.MathUtils.clamp(camDistance+dy*6e-3,minimumCameraDistance(camera?.aspect),CAMERA_FRAMING.maxDistance);},onInteract:interact,onShortcut:(key,meta={})=>{
    if(key==='x'){toggleCameraView();return;}
    if(snowJamOwnsFrame()&&!['escape','v','enter'].includes(key))return;
    if(key==='escape'){if(accountAccessPanel?.isOpen){accountAccessPanel.close();return;}if(placement&&!meta.fromInteractive){stopPortalPlacement();return;}if(state.panel){closePanel({restoreFocus:true});return;}if(!$('#creation-tools').hidden||!$('#chat-context').hidden){setComposerDisclosure(false);focusWorld();return;}if(meta.fromInteractive){focusWorld();return;}if(!$("#tool-menu").hidden){composer.setMenu(false);focusWorld();return;}closePanel();}
    if(key==='enter'){if(placement)void confirmPortalPlacement();else composer?.focus();}
    if(key==='v')openPanel('avatar');
    if(key==='c')beginCreation();
    if((key==='r'||key==='q')&&placement)placement.yawOffset+=(key==='r'?1:-1)*Math.PI/8;
    else if(key==='r')wave();
  },onNotice:toast,onLockChange:locked=>{$("#look-hint").textContent=locked?'MOUSE':'CLICK';$("#look-label").textContent=locked?'Look':'Look around';}});
  $("#composer-mode").querySelector('[value="create"]').textContent="Create";
  $("#composer-mode").setAttribute("aria-label","Message mode");
  composer=installComposer({form:$("#composer"),input:$("#composer-input"),mode:$("#composer-mode"),submit:$("#composer-submit"),menuButton:$("#menu-button"),menu:$("#tool-menu"),availability:$("#composer-availability"),getPresentation:recipient=>({...composerAvailability({recipient,capabilities:state.capabilities,local:LOCAL,explicitCreation:creationArmed,kind:creationKind,target:creationTarget,creator:ownerCreationUi?.presentation()}),placeholder:recipient==='create'?'Create · Private':'Message world · Public',...(recipient==='create'&&creationArmed&&ownerCreationUi?.accepts()&&!snowJamOwnsFrame()?{enabled:true,hint:'Private creation request. Follow progress in Create → Requests.'}:{}),...(recipient==='create'&&creationKind==='world'&&(creationTarget??state.world)?.ownerId!==(state.player?.accountId??state.player?.id)?{enabled:false,hint:'Choose one of your worlds in Worlds to edit it.'}:{}),...(recipient==='create'&&snowJamOwnsFrame()?{enabled:false,hint:'Use Back to city before sending a creation request.'}:{})}),onFocus:()=>{controls.releasePointer();if(!state.panel&&!accountAccessPanel?.isOpen)setComposerDisclosure(true);},onSubmit:submitComposer,onError:error=>addConversation(error.message,{error:true,scope:$('#composer-mode').value}),onSent:({mode})=>{composer?.refresh();accountAccessPanel?.refreshDraftNotice();if(mode==='chat'&&!accountAccessPanel?.isOpen)focusWorld();}});
  $('#composer-mode').addEventListener('change',()=>setComposerMode($('#composer-mode').value));
  for(const mode of ['chat','create'])$(`#${mode}-mode-button`).onclick=()=>{const open=$('#composer-mode').value!==mode||$(`#${mode==='chat'?'chat-context':'creation-tools'}`).hidden;closePanel();setComposerMode(mode,{focus:open,disclose:open});};
  document.querySelectorAll('[data-close-composer]').forEach(button=>button.onclick=()=>{setComposerDisclosure(false);$(`#${$('#composer-mode').value}-mode-button`).focus({preventScroll:true});});
  $('#creation-requests').onclick=()=>openPanel('requests');
  setComposerMode('chat');
  installHudLayout();
  installWorldLabel();
  const touch=window.matchMedia('(pointer: coarse)');const updateTouch=()=>document.body.classList.toggle('hud-touch',touch.matches);updateTouch();touch.addEventListener('change',updateTouch);
  mobileControls=installMobileControls({root:$('#mobile-controls'),canvas,onClear:()=>controls.clear(),getContext:()=>snowJamWalkingMobileContext()??({flying:state.player?.flying,flightAllowed:flightAllowed(state.world),placement,near:state.near,panelOpen:!!state.panel||accountAccessPanel?.isOpen===true,menuOpen:!$('#tool-menu').hidden,grounded:state.player?.grounded!==false,moving:Math.hypot(state.player?.velocityX||0,state.player?.velocityZ||0)>.35 || [...controls.keys].some(key=>['w','a','s','d','arrowup','arrowdown','arrowleft','arrowright'].includes(key))}),onAction:kind=>{
    if(kind==='interact')interact();
    else if(kind==='place')void confirmPortalPlacement();
    else if(kind==='cancel'){stopPortalPlacement();focusWorld();}
    else if(kind==='back'){closePanel();composer?.setMenu(false);focusWorld();}
  }});
  canvas.addEventListener('pointerdown',()=>{placementClickArmed=!!placement&&controls.isLocked();});
  canvas.addEventListener('click',()=>{if(placementClickArmed)void confirmPortalPlacement();placementClickArmed=false;});
  $(".brand").onclick=e=>{e.preventDefault();closePanel();composer.setMenu(false);focusWorld();};
}
function installHudLayout() {
  const hud=$('.bottom-ui'),style=document.documentElement.style;
  const measure=()=>{const height=Math.ceil(hud.getBoundingClientRect().height);if(Number.isFinite(height)&&height>0)style.setProperty('--bottom-ui-height',height+'px');};
  const observer=typeof window.ResizeObserver==='function'?new window.ResizeObserver(measure):null;
  observer?.observe(hud);window.addEventListener('resize',measure);measure();
  window.addEventListener('pagehide',event=>{if(!event.persisted){observer?.disconnect();window.removeEventListener('resize',measure);}});
}
let panelReturnFocus=null;
let accountReturnStatus=null;
let profileDraft=null;
function installWorldLabel(){
  const source=$('#world-minimap .map-title'),label=$('#header-world-name');if(!source||!label)return;
  const update=()=>{refreshValoriaReturnButton();label.textContent=headerWorldName(ssxPresentation.active()?'Snow Jam':state.world?.name);label.hidden=!label.textContent;};
  const observer=new MutationObserver(update);observer.observe(source,{childList:true,characterData:true,subtree:true});update();
  window.addEventListener('pagehide',event=>{if(!event.persisted)observer.disconnect();});
}
function setComposerDisclosure(open){
  const create=$('#composer-mode').value==='create';
  $('#creation-tools').hidden=!(open&&create);$('#chat-context').hidden=!(open&&!create);
  $('#chat-mode-button').setAttribute('aria-expanded',String(open&&!create));$('#create-mode-button').setAttribute('aria-expanded',String(open&&create));
}
function setComposerMode(mode,{focus=false,disclose=focus}={}){
  if(ssxPresentation.active()&&mode==='create')return;
  const create=mode==='create';
  if(create&&!creationArmed){creationArmed=true;creationEpoch++;creationKind='new-world';creationTarget=null;}
  composer?.setMode(create?'create':'chat');
  $('#chat-mode-button').setAttribute('aria-pressed',String(!create));$('#create-mode-button').setAttribute('aria-pressed',String(create));
  $('#experience').dataset.composerMode=create?'create':'chat';setComposerDisclosure(disclose);
  document.body.classList.toggle('creating',create);
  if(create){ownerCreationUi?.chooseKind(creationKind,creationKind==='world'?(creationTarget??state.world):creationTarget);refreshCreatorConnection();}else ownerCreationUi?.hideKind();
  refreshCreationTarget();
  if(focus)composer?.focus(create?'create':'chat');
}
function refreshCreationTarget(){
  const target=$('#creation-target');if(!target)return;const world=creationTarget??state.world;target.textContent=creationKind==='world'?(world?.ownerId===(state.player?.accountId??state.player?.id)?'Editing '+world.name:'Choose an owned world in Worlds to edit it.'):creationKind==='avatar'?'New avatar requests are reviewed before any changes.':'';target.hidden=!target.textContent;
}
function refreshNavigation(){
  refreshValoriaReturnButton();
  const section=['account','avatar','profile-edit'].includes(state.panel)?'profile':state.panel;
  $('#experience').dataset.panel=state.panel??'';$('#panel').dataset.view=state.panel??'';
  for(const name of ['worlds','profile','help']){const button=$(`#${name}-button`);if(!button)continue;button.setAttribute('aria-expanded',String(section===name));button.classList.toggle('active',section===name);}
  const account=$('#signin-button');if(account){account.hidden=LOCAL||state.account?.kind==='authenticated'&&!state.accountRefreshRequired;account.textContent=state.accountRefreshRequired?'Check sign-in':state.account?.kind==='authenticated'?'Signed in':'Sign in';account.title=state.account?.kind==='authenticated'?profileLabel(state.player):ssxPresentation.active()?'Sign in':'Sign in to Valoria';}
}
function closePanel({restoreFocus=false}={}) {
  ownedPortalManager?.destroy();ownedPortalManager=null;worldCatalog?.destroy();worldCatalog=null;
  avatarPicker?.destroy();avatarPicker=null;
  const nameForm=$('#profile-form');if(nameForm)profileDraft={identity:state.player?.accountId??state.player?.id,name:$('#player-name')?.value,username:$('#player-username')?.value};
  resortPanel?.destroy();resortPanel=null;
  state.panel=null;$("#panel").hidden=true;document.body.classList.remove('panel-open');
  if(previewRenderer){previewRenderer.dispose();previewRenderer=null;}avatarPreview?.dispose?.();avatarPreview?.root.removeFromParent();avatarPreview=null;
  refreshNavigation();if(restoreFocus){if(panelReturnFocus?.isConnected&&!panelReturnFocus.closest('[hidden]'))panelReturnFocus.focus({preventScroll:true});else $('#profile-button')?.focus({preventScroll:true});}
}
function openPanel(type,{variant='classic'}={}) {
  if(ssxPresentation.active()&&['worlds','create','ai','requests'].includes(type))return;
  if(type==='create'||type==='ai'){closePanel();setComposerMode('create',{focus:true});return;}
  if(accountAccessPanel?.isOpen)return;
  const previousFocus=document.activeElement;if(!state.panel||!$('#panel').contains(previousFocus))panelReturnFocus=previousFocus;
  controls?.releasePointer();activityDrawer?.collapse();worldMinimap.collapse();composer?.setMenu(false);setComposerDisclosure(false);closePanel();state.panel=type;$("#panel").hidden=false;document.body.classList.add('panel-open');
  $('#panel-eyebrow').textContent='';
  $('#panel').setAttribute('aria-label',['account','profile'].includes(type)?'Profile and account':type==='worlds'?'Worlds':type==='requests'?'Creation requests':'World tools');
  if(type==='resort-slots'||type==='resort-poker')resortPanel=mountResortGames($('#panel-content'),{api,kind:type==='resort-poker'?'poker':'slots',initialVariant:variant,local:LOCAL});
  if(type==='worlds')directoryPanel();
  if(type==='requests'){historySignature='';$('#panel-content').innerHTML='<button type="button" class="catalog-back" id="requests-back">Back to Create</button><h2>Your requests</h2><p id="request-action-status" role="status" hidden></p><div id="request-history"></div>';$('#requests-back').onclick=()=>openPanel('create');refreshCreationHistory();jobsPollAt=0;void pollCreationJobs();}
  if(type==='help')helpPanel();
  if(type==='profile')profilePanel();
  if(type==='profile-edit')profileEditorPanel();
  if(type==='account')accountPanel();
  if(type==='avatar')avatarPanel();
  if(type==='onboarding')onboardingPanel();
  if(type==='join-invite')invitePanel(true);
  refreshNavigation();$('#panel').scrollTop=0;$('#panel').focus({preventScroll:true});
}
function refreshCreatorConnection(){
  const root=$('#creator-connection');if(!root)return;
  const restore=root.contains(document.activeElement);
  ownerCreationUi?.appendConnect(root,{compact:true,onSignIn:()=>accountAccessPanel.open()});
  const requests=$('#creation-requests');if(requests){requests.disabled=!ownerCreationUi?.available();requests.hidden=requests.disabled;}
  const view=ownerCreationUi?.presentation(),details=$('#creator-connection-details'),kind=$('#creation-kind-details');
  if(details&&view){if(details.dataset.state!==view.state)details.open=view.state!=='connected';details.dataset.state=view.state;details.querySelector('summary').textContent=view.state==='connected'?'Creator connected':'Creator connection';details.querySelector('summary').hidden=view.state!=='connected';}
  if(kind)kind.hidden=!view?.canChoose;
  $('#composer-availability')?.classList.toggle('sr-only',!view?.canChoose);
  if(restore)root.querySelector('button,a')?.focus({preventScroll:true});
}
function invitePanel() {
  const root=$('#panel-content');root.innerHTML='<h2>Join your friend</h2><p>Join near your friend in their current world, if a safe place is available.</p><p id="invite-status" role="status"></p>';
  const status=$('#invite-status');
  if(LOCAL||!state.capabilities?.friendInvites){status.textContent='Joining a friend is unavailable in this session.';return;}
  const token=pendingInviteToken;if(!token){status.textContent='This invite link is invalid. Ask your friend for a new one.';return;}
  const button=document.createElement('button');button.type='button';button.className='secondary';button.textContent='Join friend';root.append(button);
  button.onclick=async()=>{button.disabled=true;status.textContent='Finding a safe place nearby…';try{
    if(!state.connected)throw Error('Connect to the world before joining your friend.');
    controls?.clear();const result=await api('/api/friend-invites/join',{token});pendingInviteToken=null;
    if(!result.replayed&&result.player&&result.world)handleServerMessage({type:'invited',player:result.player,world:result.world});
    closePanel();toast(result.replayed?'You have already used this invitation.':'You joined your friend.');
  }catch(error){status.textContent=error.message;button.disabled=false;}};
}
function pauseForUncertainAccount() {
  // A mutation may have changed the session. Keep the draft, but stop using its old authority.
  controls?.clear();
  state.accountRefreshRequired=true;state.accountUncertain=true;state.connected=false;
  httpTransport?.dispose();httpTransport=null;
  const socket=state.socket;state.socket=null;socket?.close();
  ownerCreationUi?.dispose();
  snowJamObserve({type:'accountChanged',code:'ACCOUNT_CHANGED'});liveContent?.setConnected(false);
  remotePresence?.clear();pendingPresence=null;
  composer?.refresh();refreshCreatorConnection();refreshNavigation();
  $('#save-status').textContent='Sign-in needs checking · reload to continue';
}
function profilePanel() {
  $('#panel-content').innerHTML=profileSummaryMarkup({name:profileLabel(state.player),username:state.player.username,authenticated:!LOCAL&&state.account?.kind==='authenticated',thumbnail:catalogThumbnail('avatar',state.player.avatar?.preset)});
  $('#profile-edit-name').onclick=()=>openPanel('profile-edit');
  $('#profile-open-avatar').onclick=()=>openPanel('avatar');
  $('#profile-open-account').onclick=()=>openPanel('account');
}
function accountPanel(){
  $('#panel-content').innerHTML=accountSummaryMarkup({local:LOCAL,authenticated:state.account?.kind==='authenticated',refreshRequired:state.accountRefreshRequired,name:profileLabel(state.player)});
  $('#profile-back').onclick=()=>openPanel('profile');
  const button=$('#account-open-auth');if(button)button.onclick=()=>accountAccessPanel.open();$('#account-open-help').onclick=()=>openPanel('help');
}
function avatarPanel(){
  $('#panel-content').innerHTML=avatarHeadingMarkup();$('#profile-back').onclick=()=>openPanel('profile');
  const browseState=prepareCatalogState('avatar');
  avatarPicker=mountAvatarPicker($('#profile-avatar-picker'),{getConfig:()=>state.player.avatar,creations:state.creations,account:state.account,createPortrait:portrait,save:snowJamSaveAvatarChoice,onSaved:()=>toast('Avatar selected.'),onCreate:entry=>beginCreation('avatar',entry),browse:true,browseState,onFavoritesChange:favorites=>persistCatalogFavorites('avatar',favorites)});
  $('#avatar-create').onclick=()=>avatarPicker?.create();
  if(snowJamOwnsFrame()){$('#avatar-create').disabled=true;$('#avatar-create').title='Use Back to city before creating an avatar.';}
  snowJamLimitAvatarPicker($('#profile-avatar-picker'));
}
function catalogStorage(){try{return globalThis.localStorage;}catch{return null;}}
function prepareCatalogState(kind){
  const stateForKind=directoryBrowseState[kind],scope=state.player?.accountId??state.player?.id??'guest';
  if(stateForKind.favoriteScope!==scope){stateForKind.favorites=readCatalogFavorites(catalogStorage(),scope,kind);stateForKind.favoriteScope=scope;}
  return stateForKind;
}
function persistCatalogFavorites(kind,favorites){saveCatalogFavorites(catalogStorage(),directoryBrowseState[kind].favoriteScope,kind,favorites);}
function profileEditorPanel(){
  $('#panel-content').innerHTML=profileEditorMarkup({authenticated:!LOCAL&&state.account?.kind==='authenticated'});$('#profile-back').onclick=()=>openPanel('profile');
  const form=$('#profile-form'),input=$('#player-name'),username=$('#player-username'),message=$('#profile-message');const draft=profileDraft?.identity===(state.player.accountId??state.player.id)?profileDraft:null;input.value=draft?.name??suggestedProfileName(location.search)??state.player.profileName??state.player.name;
  if(username)username.value=draft?.username??state.player.username??state.account.username??'';
  form.onsubmit=async event=>{event.preventDefault();const button=form.querySelector('button');button.disabled=true;message.textContent='';try{
    const name=input.value.trim();if(!name)throw Error('Choose a display name.');
    await saveAvatarSelection(state.player.avatar,{name,...(username?{username:username.value.trim().toLowerCase()}:{}),...(needsProfileSetup(state.player,{local:LOCAL,capabilities:state.capabilities,account:state.account})?{completeProfile:true}:{})});
    $('#profile-name').textContent=profileLabel(state.player);if(username)state.account={...state.account,username:state.player.username,needsUsername:false};message.textContent=pendingPersistenceNotice?.message??'Profile saved.';profileDraft=null;refreshNavigation();
    const url=new URL(location.href);url.searchParams.delete('name');history.replaceState(null,'',url.href);
  }catch(error){message.textContent=error.message;}finally{if(button.isConnected)button.disabled=false;}};
}
function directoryPanel() {
  ownedPortalManager?.destroy();ownedPortalManager=null;worldCatalog?.destroy();worldCatalog=null;
  $("#panel-content").innerHTML=directoryHeadingMarkup();
  $("#directory-create").onclick=()=>beginCreation('new-world');
  const list=$("#directory-list");
  if(snowJamOwnsFrame()){$("#directory-create").disabled=true;$("#directory-create").title="Use Back to city before creating.";}
  list.classList.add('world-catalog');
  const browser=document.createElement('div'),detail=document.createElement('section');detail.className='catalog-detail';detail.setAttribute('aria-label','World details');detail.tabIndex=-1;detail.hidden=true;list.append(browser,detail);
  const showWorld=({source:world})=>{
    browser.hidden=true;detail.hidden=false;detail.replaceChildren();
    const back=document.createElement('button');back.type='button';back.className='catalog-back';back.textContent='Back to results';back.onclick=()=>{detail.hidden=true;browser.hidden=false;worldCatalog?.focusSelected();};detail.append(back);
    const card=document.createElement('article');card.className='world-card directory-card';
    const cover=document.createElement('div');cover.className='world-detail-art';cover.setAttribute('aria-hidden','true');
    const thumbnail=catalogThumbnail('world',world.id);
    if(thumbnail){const image=document.createElement('img');image.src=thumbnail;image.alt='';image.decoding='async';image.onerror=()=>{image.hidden=true;};cover.append(image);}
    card.append(cover);
    const heading=document.createElement('strong');heading.textContent=world.name;card.append(heading);
    if(world.id===state.world.id){const here=document.createElement('small');here.textContent='You are here';card.append(here);}
    const actions=document.createElement('div');actions.className='card-actions';
    const place=document.createElement('button');place.className='primary';place.textContent=world.playSession?.status==='closed'&&world.ownerId===(state.player.accountId??state.player.id)?'Start session':'Place portal';place.onclick=async()=>{if(!await snowJamPrepareWorldAction())return;if(world.playSession?.status==='closed'){if(world.ownerId!==(state.player.accountId??state.player.id)){toast('Ask the owner to start a new session.');return;}place.disabled=true;try{await api('/api/play-sessions',{worldId:world.id,audience:world.playSession.audience,capacity:world.playSession.capacity});state.worlds=snowJamOrdinaryWorlds((await api('/api/worlds')).worlds);await beginPortalPlacement(world.id);}catch(error){toast(error.message);}finally{place.disabled=false;}}else beginPortalPlacement(world.id);};actions.append(place);
    const edit=document.createElement('button');edit.className='secondary';edit.textContent=world.ownerId===(state.player.accountId??state.player.id)?'Edit':'Create a new world';edit.onclick=()=>world.ownerId===(state.player.accountId??state.player.id)?beginCreation('world',world):beginCreation('new-world');if(snowJamOwnsFrame()){edit.disabled=true;edit.title='Use Back to city before creating or editing.';}actions.append(edit);
    const description=document.createElement('p');description.textContent=world.description||'Choose an action for this world.';card.append(description);
    const note=document.createElement('p');note.className='note';note.textContent=snowJamOwnsFrame()?'Placing a doorway returns you through your entry doorway first. Then walk or fly through it to enter.':'Place a doorway nearby, then walk or fly through it to enter.';card.append(note,actions);detail.append(card);
  };
  const showActivity=item=>{
    browser.hidden=true;detail.hidden=false;detail.replaceChildren();
    const back=document.createElement('button');back.type='button';back.className='catalog-back';back.textContent='Back to results';back.onclick=()=>{detail.hidden=true;browser.hidden=false;worldCatalog?.focusSelected();};detail.append(back);
    const card=document.createElement('article');card.className='world-card directory-card';
    const cover=document.createElement('div');cover.className='world-detail-art world-detail-art-snow';cover.setAttribute('aria-hidden','true');card.append(cover);
    const heading=document.createElement('strong');heading.textContent=item.name;
    const description=document.createElement('p');description.textContent=item.description;
    const note=document.createElement('p');note.className='note';note.textContent=snowJamOwnsFrame()?'Placing a doorway returns you through your entry doorway first.':'These courses share one connected mountain. This portal chooses where you enter.';
    const place=document.createElement('button');place.className='primary';place.textContent='Place portal';place.onclick=()=>void beginPortalPlacement(item.id);
    card.append(heading,description,note,place);detail.append(card);detail.focus({preventScroll:true});detail.scrollIntoView({block:'nearest'});
  };
  const items=snowJamCatalogItems(worldCatalogItems(state.worlds,{ownerId:state.player.accountId??state.player.id,currentId:state.world.id}));
  worldCatalog=mountCatalogBrowser(browser,{items,noun:'worlds',filters:[['mine','My creations'],['flight','Flight enabled'],['current','Current world'],...snowJamCatalogFilters()],state:prepareCatalogState('worlds'),onFavoritesChange:favorites=>persistCatalogFavorites('worlds',favorites),onSelect:item=>{if(snowJamSelectCatalogItem(item,showActivity))return;showWorld(item);detail.focus({preventScroll:true});detail.scrollIntoView({block:'nearest'});}});
  if(!LOCAL)ownedPortalManager=mountOwnedPortalManager(list,{api,getIdentity:()=>state.player?.accountId??state.player?.id,beforeRemove:async()=>{if(snowJamOwnsFrame())throw Error('Return to Valoria before removing an active doorway.');return true;},onApplied:async result=>{
    for(const world of snowJamOrdinaryWorlds(result.worlds??[])){worldCache.set(world.id,world);if(world.id===state.world.id)enterWorld(world,false);else portals.registerWorld(world);}
    await snowJamMount?.refreshAvailability?.({prepare:false});
  }});
  const selected=items.find(item=>item.id===directoryBrowseState.worlds.selected);
  // Reopening the directory returns to the retained search and filters.
}
function onboardingPanel() {
  $('#panel-content').innerHTML='<h2>'+ (ssxPresentation.active()?'Welcome to SSX 3':'Welcome to Valoria') +'</h2><p>Choose your display name and a default avatar. You can change them later in Profile.</p><div id="onboarding-picker"></div>';
  avatarPicker=mountAvatarPicker($('#onboarding-picker'),{getConfig:()=>state.player.avatar,creations:state.creations,createPortrait:portrait,save:saveAvatarSelection,onboarding:true,account:state.account,displayName:suggestedProfileName(location.search)??state.player.profileName??state.player.name,onSaved:()=>{
    $('#profile-name').textContent=profileLabel(state.player);if(state.account?.kind==='authenticated')state.account={...state.account,username:state.player.username,needsUsername:false};closePanel();
    const url=new URL(location.href);url.searchParams.delete('name');history.replaceState(null,'',url.href);
    if(pendingInviteToken!==null)openPanel('join-invite');else focusWorld();
  }});
}
function portrait(canvas,config) {
  previewRenderer = new T.WebGLRenderer({ canvas, alpha: true, antialias: true });
  previewRenderer.setPixelRatio(Math.min(devicePixelRatio, 1.5));
  previewRenderer.outputColorSpace = T.SRGBColorSpace;
  previewRenderer.toneMapping = T.ACESFilmicToneMapping;
  previewScene = new T.Scene();
  previewScene.add(new T.HemisphereLight("#e6e9ff", "#6a5b68", 2.4));
  const l = new T.DirectionalLight("#ffe3cd", 3);
  l.position.set(2, 4, 4);
  previewScene.add(l);
  avatarPreview = createAvatar(config);
  previewScene.add(avatarPreview.root);
  previewCamera = new T.PerspectiveCamera(31, 1, 0.1, 20);
  previewCamera.position.set(0, 1.45, 3.7);
  previewCamera.lookAt(0, 1, 0);
  // Measure the stable preview box, not a canvas hidden while its model loads.
  // Keep CSS in charge of layout; setSize's third argument prevents inline sizes.
  const portraitRenderer=previewRenderer,portraitCamera=previewCamera,previewBox=canvas.parentElement??canvas;
  let disposed=false,lastWidth=0,lastHeight=0;
  const resize=()=>{
    if(disposed)return;
    const width=Math.round(previewBox.clientWidth),height=Math.round(previewBox.clientHeight);
    if(width<=0||height<=0||(width===lastWidth&&height===lastHeight))return;
    lastWidth=width;lastHeight=height;
    portraitRenderer.setSize(width,height,false);portraitCamera.aspect=width/height;
    // Preserve a full-body envelope on the narrower phone preview column.
    const distance=Math.max(4.2,1.5/(2*Math.tan(31*Math.PI/360)*portraitCamera.aspect));
    portraitCamera.position.set(0,1.2,distance);portraitCamera.lookAt(0,1,0);portraitCamera.updateProjectionMatrix();
  };
  const observer=typeof ResizeObserver==='function'?new ResizeObserver(resize):null;
  observer?.observe(previewBox);window.addEventListener('resize',resize);resize();
  const dispose=avatarPreview.dispose?.bind(avatarPreview);
  avatarPreview.dispose=()=>{if(disposed)return;disposed=true;observer?.disconnect();window.removeEventListener('resize',resize);dispose?.();};
  return avatarPreview;
}
let placement=null,placementGhost=null,placementClickArmed=false,placementRequest=0;
const placementPreview=createPortalPlacementPreview();
function stopPortalPlacement() {
  placementRequest++;placementPreview.clear();placement=null;placementClickArmed=false;placementGhost?.removeFromParent();
  if(placementGhost){placementGhost.geometry.dispose();placementGhost.material.dispose();placementGhost=null;}
  $("#placement-controls")?.remove();
}
async function beginPortalPlacement(worldId) {
  const request=++placementRequest;
  if(worldId==="snowjam"||!await snowJamPrepareWorldAction())return;
  if(request!==placementRequest)return;
  const sourceWorldId=state.world.id,destination=ssxCatalogDestination(worldId),activity=!!destination;
  try {
    if(activity&&!snowJamCatalogReady())throw Error('Snow Jam is unavailable. Reopen Worlds to refresh.');
    const target=activity?null:await resolveWorld(worldId);
    if(!canPlacePortalBetween(state.world,target??state.world,state.player.accountId??state.player.id))throw Error('Place a portal between your own world and Valoria, or between worlds you own.');
    if(activity){const status=await snowJamMount.refreshAvailability({prepare:false});if(status.canPlaceDoorway===false||!((status.courseDestinations??[{id:'snowjam'}]).some(item=>item.id===destination.id)))throw Error('This SSX course doorway is unavailable here.');}
    await Promise.all([prepareSpawnSafety(state.world),...(target?[prepareSpawnSafety(target)]:[])]);
    if(request!==placementRequest||state.world.id!==sourceWorldId)return;
    stopPortalPlacement();closePanel();composer?.setMenu(false);
    placement={activity:activity?'snowjam':null,courseId:destination?.id,width:destination?.doorwayWidth??3.2,height:destination?.doorwayHeight??3.4,sourceWorldId:state.world.id,targetWorldId:worldId,yawOffset:0,target,candidate:null,busy:false,requestId:crypto.randomUUID()};
    const box=new T.BoxGeometry(destination?.doorwayWidth??3.2,destination?.doorwayHeight??3.4,.10),edges=new T.EdgesGeometry(box);box.dispose();
    placementGhost=new T.LineSegments(edges,new T.LineBasicMaterial({color:'#baf8de',transparent:true,opacity:.85}));
    placementGhost.name='Portal placement guide';scene.add(placementGhost);
    const hud=document.createElement('div');hud.id='placement-controls';hud.innerHTML='<span id="placement-message" role="status"></span><div><button type="button" id="placement-rotate" aria-label="Rotate portal">Rotate</button><button type="button" id="placement-confirm">Place</button><button type="button" id="placement-cancel">Cancel</button></div>';
    $('#hud-base').append(hud);$('#placement-rotate').onclick=()=>{if(placement)placement.yawOffset+=Math.PI/8;focusWorld();};$('#placement-confirm').onclick=()=>void confirmPortalPlacement();$('#placement-cancel').onclick=()=>{stopPortalPlacement();focusWorld();};
    updatePortalPlacement();focusWorld();
  }catch(error){toast(error.message);}
}
function updatePortalPlacement({force=false}={}){
  if(!placement)return;
  if(placementGhost?.parent!==scene)scene.add(placementGhost);
  if(state.world.id!==placement.sourceWorldId){stopPortalPlacement();return;}
  if(placement.busy&&!force){const message=$('#placement-message');if(message.textContent!=='Placing portal…')message.textContent='Placing portal…';$('#placement-confirm').disabled=true;return;}
  const trackedYaw=xrPresentation?.headingYaw();const placementYaw=camYaw+(Number.isFinite(trackedYaw)?trackedYaw:0)+Math.PI;
  const candidate=placementPreview.sample({world:snowJamMount?.placementWorld?.(state.world)??state.world,player:{...state.player,yaw:placementYaw},yawOffset:placement.yawOffset,width:placement.width,height:placement.height,players:[...state.players.values()],force});placement.candidate=candidate;
  if(candidate.portal){placementGhost.position.set(candidate.portal.position.x,candidate.portal.position.y+(placement.height??3.4)/2,candidate.portal.position.z);placementGhost.rotation.y=candidate.portal.yaw;placementGhost.visible=true;}else placementGhost.visible=false;
  placementGhost.material.color.set(candidate.valid?'#baf8de':'#f0a0a0');
  const message=placement.busy?'Placing portal…':candidate.valid?'Q / R rotate · Enter to place':candidate.reason;
  if($('#placement-message').textContent!==message)$('#placement-message').textContent=message;
  const disabled=placement.busy||!candidate.valid;if($('#placement-confirm').disabled!==disabled)$('#placement-confirm').disabled=disabled;
}
async function confirmPortalPlacement(){
  if(snowJamOwnsFrame())return;
  const active=placement;if(!active||active.busy)return;updatePortalPlacement({force:true});if(placement!==active||!active.candidate?.valid)return;
  active.busy=true;updatePortalPlacement();
  try{
    const source=active.candidate.portal;
    const request={sourceWorldId:active.sourceWorldId,source:{position:{...source.position},yaw:source.yaw},sourceRevision:state.world.revision,requestId:active.requestId,...(active.activity?{courseId:active.courseId}:{targetWorldId:active.targetWorldId,targetRevision:active.target.revision})};
    let result;
    if(LOCAL){
      result=createPlacedPortalPair(state.localWorlds,request,{actorId:state.player.id,player:state.player,pairId:'place_'+crypto.randomUUID().replaceAll('-',''),players:[...state.players.values()]});
      for(const world of result.worlds)state.localWorlds[world.id]=world;
      state.worlds=summaries();persist();
    }else result=await api(active.activity?'/api/activities/snowjam/doorways':'/api/portal-pairs',request);
    for(const world of snowJamOrdinaryWorlds(result.worlds)){worldCache.set(world.id,world);if(world.id===state.world.id)enterWorld(world,false);else portals.registerWorld(world);}
    if(placement===active)stopPortalPlacement();
    if(active.activity)await snowJamMount.refreshAvailability({prepare:false});else selectPortal(result.sourcePortal);toast('Portal placed.');focusWorld();
  }catch(error){if(placement===active){active.busy=false;updatePortalPlacement();}toast(error.message);}
}

function helpPanel() {
  $("#panel-content").innerHTML=`<button type="button" class="catalog-back" id="help-back">Back to Account</button><h2>Controls</h2><div class="help-grid"><kbd>X</kbd><span>First / third person</span><kbd>W A S D</kbd><span>Move</span><kbd>CLICK</kbd><span>Look around</span><kbd>SPACE</kbd><span>Jump</span><kbd>SHIFT</kbd><span>Run</span><kbd>ENTER</kbd><span>Chat or create</span><kbd>E</kbd><span>Interact</span><kbd>ESC</kbd><span>Leave typing, release the mouse, or close a panel</span></div><p class="note">Phone: left stick moves, right stick looks. Pinch the world to zoom. A and B show their current actions; A jumps while moving. Close the panel to return to the game controls.</p><details><summary>Connection</summary><p class="note">${LOCAL?'This session is saved on this device.':escape(pendingPersistenceNotice?.message??(state.connected?'Connected.':'Reconnecting…'))}</p></details><details><summary>Performance check</summary><button class="secondary" id="record-performance">Record 20 seconds</button><button class="secondary" id="download-performance">Download timing sample</button></details>`;
  $('#help-back').onclick=()=>openPanel('account');
  $("#record-performance").onclick=()=>{diagnostics.start();closePanel();focusWorld();toast('Recording timings for 20 seconds.');};
  $("#download-performance").onclick=()=>{diagnostics.stop();const url=URL.createObjectURL(new Blob([JSON.stringify(window.valoriaDiagnostics.snapshot(),null,2)],{type:'application/json'})),a=document.createElement('a');a.href=url;a.download='valoria-performance.json';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);};
}
const arrivalRecovery=LOCAL?null:createArrivalRecovery({loading:$("#loading"),request:api});
boot().catch((e) => {
  console.error(e);
  if(e.code==='SIGN_IN_REQUIRED'){
    $("#loading h2").textContent=ssxPresentation.active()?'SSX 3':'Valoria';$("#loading-status").textContent='Sign in to enter.';
    const link=document.createElement('a');link.href='/signin-with-chatgpt?return_to='+encodeURIComponent(snowJamSignInReturnTo);link.textContent='Continue with ChatGPT';link.className='signin-link';$("#loading").append(link);return;
  }
  const webgl = /WebGL/.test(e.message);
  $("#loading h2").textContent = webgl ? "This world needs 3D graphics." : "Arrival interrupted.";
  $("#loading-status").textContent = webgl ? "WebGL 2 is unavailable in this browser. Open this game in a browser with 3D graphics enabled." : e.message;
  const p = document.createElement("p");
  p.textContent = webgl ? (pendingPersistenceNotice?.message??"Your saved world and profile are safe.") : "Reload to try arriving again.";
  $("#loading").appendChild(p);
});

